/* ALL THE SCRIPTS IN THIS FILE ARE MADE BY KROWNTHEMES.COM --- REDISTRIBUTION IS NOT ALLOWED! */
  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function(root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function(eventType) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam
    });
    return this;
  };
  Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function(event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function(event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function() {
    this.off();
    this.root();
  };
  var main_default = Delegate;
$(window).bind("pageshow", function(event) {
if (event.originalEvent.persisted) {
      window.location.reload()
    }
});

$.ajaxSetup({ cache: false });

// CONTINUE WITH EVERYTHING ELSE

// discounts 

class Discounts extends HTMLElement {
	static delegateBody;
	static delegateElement;

	constructor() {
		super();
		this.element = this;		

        if (Shopify.designMode) return;

		this.discounts = theme.discountCodes;
		this.discountOpen = false;

		const _this = this;
		$(document).on('ready', function(){			
			_this.checkDiscountCode();
		});
	}

	connectedCallback() {
		if (Discounts.delegateBody) Discounts.delegateBody.destroy();
		if (Discounts.delegateElement) Discounts.delegateElement.destroy();

		Discounts.delegateBody = new Delegate(document.body);
		Discounts.delegateElement = new Delegate(this.element);

		Discounts.delegateBody.on("refresh:discount", this.checkDiscountCode.bind(this));
		Discounts.delegateElement.on("click", "[data-click=enter-vaucher]", this.discountInputClick.bind(this));
		Discounts.delegateElement.on("keydown", this.simulateClick.bind(this));
		Discounts.delegateElement.on("click", '[data-action="submit-code"]', this.checkDiscountCode.bind(this));
		Discounts.delegateElement.on("click", '[data-action="edit-discount"]', this.editDisocount.bind(this));
	}

	// input functions

	checkDiscountCode() {			
		event.preventDefault();
		event.stopPropagation();
		
		// get discount code from input or session storage
		const input = this.element.querySelector(".cart__discount-input");	
		const params = new URLSearchParams(window.location.search)
		const discountParam = params.get("discount");
			
		let value = input?.value.trim().toLowerCase() || discountParam?.toLowerCase();
				
		if (value === "" && event.type === "click") {					
			this.currentDiscount = false;
			this.conditionMeet = false;
			this.currentCodeX = false;

			this.setToStartingState(input);
			this.setDiscounts();

			return;
		}
		
		this.currentCode = value || sessionStorage.getItem('discount_code');
		if (!this.currentCode) return;
		
		// check if entered code matches discount codes
		const isCodeRight = this.checkDiscount(this.currentCode);

		// set input state
		if (!isCodeRight) this.setInputStateToError();
		else this.setInputStateSucces();
		
		// update session storage and set new discounts around the page
		this.setCookie('discount_code_temp', this.currentCode, 30);
		this.setCookie('discount_code', this.currentCode, 30);
		sessionStorage.setItem('discount_code', this.currentCode);

		this.setDiscounts()
	}

	// we use cookie instead of session
	getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}

		return false;
	}

	setCookie(name,value,days) {
		var expires = "";
		if (days) {
		  var date = new Date();
		  date.setTime(date.getTime() + (days*24*60*60*1000));
		  expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

	setToStartingState(input) {		
		input.classList.remove("active");
		input.placeholder = window.theme.cartInputCodePlaceholder;
		document.querySelector("#site-cart").focus();

		sessionStorage.removeItem("discount_code");
		this.setCookie('discount_code_temp', '', 30);
		this.setCookie('discount_code', '', 30);
	}

	simulateClick(event) {		
		if (event.key === 'Enter' || event.keyCode === 13) {
			event.preventDefault();
			event.stopPropagation();

			this.element.querySelector(".cart__discount-ok-button").click();
		}
	}

	discountInputClick() {
		const target = event.target;
		const classList = target.classList;
	
		if (classList.contains('cart__discount-input') || classList.contains('cart__discount-ok-button')) {
			if (this.discountOpen) return;
	
			classList.add('active');
			target.placeholder = "";
		} 
	}

	editDisocount(){
		const discountWrapper = this.element.querySelector('.cart__discount-wrapper');
		const successDiv = this.element.querySelector('.cart__discount-success');

		discountWrapper.setAttribute("aria-hidden", "false");
		successDiv.setAttribute("aria-hidden", "true");

		const input = this.element.querySelector('.cart__discount-input');

		input.classList.add('active');
		input.value = this.currentCode;
		input.focus();
	}	

	setInputStateToError() {
		this.element.classList.add("error");

		setTimeout(() => {
			this.element.classList.remove("error");
		}, 1000)
	}

	setInputStateSucces() {
		const discountWrapper = this.element.querySelector('.cart__discount-wrapper');
		const successDiv = this.element.querySelector(".cart__discount-success");

		successDiv.querySelector(".cart__discount-current-code").innerText = this.currentCode;

		discountWrapper.setAttribute("aria-hidden", "true");
		successDiv.setAttribute("aria-hidden", "false");
	}

	setXCode() {
		const successDiv = this.element.querySelector(".cart__discount-success");
		if (!successDiv) return; 

		successDiv.querySelector(".cart__discount-current-code").innerText = this.currentCode + "X";
		this.setCookie('discount_code_temp', this.currentCode + "X", 30);
		this.setCookie('discount_code', this.currentCode + "X", 30);
	}

	// discount functions

    checkDiscount(discountCode) {		
		this.currentDiscount = this.discounts[discountCode];
		return this.currentDiscount ? true : false;
    }

    setDiscounts() {	
		this.checkCondition();
		
		if (!this.conditionMeet) {
			this.removePriceDiscounts();
			this.removeWrittenDiscounts();
			this.setPriceOnOneMoreProducts();

		} else {
			if (this.currentCodeX) this.setXCode();			

			this.setPriceDiscounts();
			this.setWrittenDiscounts();
		}
    }

	checkCondition() {
		this.conditionMeet = false;
		this.currentCodeX = false;
		this.oneMoreTillDiscount = [];
		this.dontApplyOn = this.currentDiscount?.dont_apply_discounts_on || [];		
				
		if (!this.currentDiscount) return;
		if (!this.currentDiscount.use_minimum_list_x && !this.currentDiscount.use_minimum_cart && !this.currentDiscount.use_minimum_list)
			return this.conditionMeet = true;

		const cart = document.querySelector("#site-nav--mobile") || document.querySelector("#section-cart");
		const cartItems = Array.from(cart.querySelectorAll("cart-drawer .cart-item"));
		const idsInCart = cartItems.map(item => item.dataset.variantId);		

		/**************************************** product list x condition ****************************************/
		if (this.currentDiscount.use_minimum_list_x) {
			const { product_list_x: conditionIds, minimum_list_x: minimumAmount } = this.currentDiscount;

			const filteredList = idsInCart.filter(id => conditionIds.includes(id));
			const totalQuantity = this.calculateTotalQuantity(filteredList); 	
				
			if (totalQuantity >= minimumAmount) {
				this.conditionMeet = true;
				this.currentCodeX = true;
			} 
		}

		/**************************************** amount condition ****************************************/ 
		if (this.currentDiscount.use_minimum_cart) {
			const minimumAmount = this.currentDiscount.minimum_cart;
			const cartAmount = Number(document.querySelector(".CartMain").dataset.quantityTotal);

			if (cartAmount >= minimumAmount) this.conditionMeet = true;
		}

		/**************************************** product list condition ****************************************/
		if (this.currentDiscount.use_minimum_list) {			
			const { product_list: conditionIds, minimum_list: minimumAmount } = this.currentDiscount;
			const filteredList = idsInCart.filter(id => conditionIds.includes(id));
			const totalQuantity = this.calculateTotalQuantity(filteredList);

			if (totalQuantity >= minimumAmount) {
				this.conditionMeet = true;
				this.showUpsellMsg(filteredList);
			} else if (totalQuantity === minimumAmount - 1) {
				this.showUpsellMsg(filteredList);
				this.oneMoreTillDiscount = this.oneMoreTillDiscount.concat(conditionIds);
			} else {
				this.hideUpsellMsg();
			}
		}		
	}

	// Helper to calculate the total quantity of matching items in the cart
	calculateTotalQuantity(filteredIds) {
		return filteredIds
			.map(id => parseFloat(document.querySelector(`.cart-item[data-variant-id="${id}"]`).dataset.itemAmount))
			.reduce((sum, amount) => sum + amount, 0);
	}

	showUpsellMsg(idsInCart) {						
		const productId = idsInCart[0];
		const msg = document.querySelector(`.discount_2nd_item[data-variant-id="${productId}"]`);
		
		if (!msg) return;

		//const discount = this.currentDiscount.amount;
		const item = document.querySelector(`.cart-item[data-variant-id="${productId}"]`);
		if (!item) return msg.classList.remove("flow-in");

		let price = item.querySelector("[data-override-value]").dataset.overrideValue;
		let compare = item.querySelector("[data-override-compare]")?.dataset.overrideCompare || price;

		price = Math.round(price - price * (this.currentDiscount.amount / 100));		
		
		const discount = Math.round((1 - price / compare) * 100);
		
		const msg_text = msg.querySelector("span");
		msg_text.innerText = window.theme.flyInDiscountFirst + " " + discount + window.theme.flyInDiscountSecond;

		msg.classList.add("flow-in");
	}

	hideUpsellMsg() {
		const msgs = document.querySelectorAll(`.discount_2nd_item.flow-in`);
		msgs.forEach(msg => {
			msg.classList.remove("flow-in")
		})
	}

	setPriceOnOneMoreProducts() {		
		if (!this.oneMoreTillDiscount.length) return;

		let priceElems = [], writtenDiscountElems = [];

		this.oneMoreTillDiscount.forEach(id => {
			const tempPriceElems = document.querySelectorAll(`[data-variant-id="${id}"][data-override-value]:not(.cart__item-price)`);
			if (tempPriceElems.length) priceElems = priceElems.concat(Array.from(tempPriceElems));

			const tempWrittenDiscountElems = document.querySelectorAll(`.Discount__Regular[data-variant-id="${id}"]`);
			if (tempWrittenDiscountElems.length) writtenDiscountElems = writtenDiscountElems.concat(Array.from(tempWrittenDiscountElems));
		})
		
		const oneMore = true;
		this.setPriceDiscounts(priceElems);
		this.setWrittenDiscounts(writtenDiscountElems, oneMore);
	}

	setPriceDiscounts(priceElems) {				
		priceElems = priceElems || document.querySelectorAll('[data-override-value]:not([data-total-price="true"])');

		priceElems.forEach(priceElem => {
			const id = priceElem.dataset.variantId;

			if (!this.dontApplyOn.includes(id)) {				
				const parent = priceElem.parentElement.parentElement;
				const compareElem = parent.querySelector("[data-override-compare]");
	
				const price = this.currentDiscount.discount_from_compare ? compareElem.dataset.overrideCompare || priceElem.dataset.overrideValue : priceElem.dataset.overrideValue;
				const comparePrice = compareElem.dataset.overrideCompare || priceElem.dataset.overrideValue;
					
				let newCompare = theme.Currency.formatMoney(comparePrice, window.shop_money_format);
				const bundleUnit = compareElem.dataset.bundleUnit;
				if (bundleUnit) newCompare = newCompare + bundleUnit;
	
				compareElem.innerText = newCompare;
	
				this.calculateDiscount(priceElem, price);
			} 
		})

		this.setTotalPrice();
	}

	removePriceDiscounts() {
		const priceElems = document.querySelectorAll("[data-override-value]");

		priceElems.forEach(priceElem => {
			const parent = priceElem.parentElement.parentElement;
			const compareElem = parent.querySelector("[data-override-compare]");

			const price = priceElem.dataset.overrideValue;
			const compare = compareElem.dataset.overrideCompare;

			if (compare === price || !compare) compareElem.innerText = "";

			this.resetPrice(priceElem, price);
		})
	}

	calculateDiscount(item, price) {		
		if (!item || !price) return;
		
		const discountedPrice = price * ((100 - this.currentDiscount.amount) / 100);
		const newPrice = theme.Currency.formatMoney(Math.ceil(discountedPrice), window.shop_money_format);
		const unit = item.dataset.bundleUnit || "";
		
		item.setAttribute("data-active-discount", this.currentDiscount.code);
		item.setAttribute("data-price-after-discount", Math.ceil(discountedPrice));

		item.innerText = newPrice + unit;
	}

	resetPrice(item, price) {
		if (!item || !price) return;
		
		const newPrice = theme.Currency.formatMoney(price, window.shop_money_format);
		item.removeAttribute("data-active-discount");
		item.setAttribute("data-price-after-discount", price);

		const unit = item.dataset.bundleUnit || "";
		item.innerText = newPrice + unit;
	}

	setWrittenDiscounts(discounts) {
		let oneMore = false;

		if (discounts) oneMore = true;
		discounts = discounts || document.querySelectorAll(`.Discount__Regular:not([data-active-discount="${this.currentDiscount.code}"])`);		

		discounts.forEach(item => {
			const id = item.dataset.variantId;

			if (!this.dontApplyOn.includes(id)) {
				this.calculateWrittenDiscount(item, oneMore);
			}
		})
	}

	removeWrittenDiscounts() {
		let oneMore = false;
		const discount = document.querySelectorAll(`.Discount__Regular`);

		discount.forEach(item => {
			this.calculateWrittenDiscount(item, oneMore);
		})
	}

	calculateWrittenDiscount(item, oneMore) {				
		const svg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M2.48202 13.0409L1.55745 12.4917C1.14802 12.2485 0.894693 11.8097 0.888795 11.3336L0.875477 10.2583C0.872647 10.0298 0.812608 9.80578 0.700848 9.60654L0.174734 8.66865C-0.0582446 8.25332 -0.0582446 7.74668 0.174734 7.33135L0.700848 6.39346C0.812608 6.19422 0.872647 5.97015 0.875477 5.74173L0.888795 4.66644C0.894693 4.19026 1.14802 3.75149 1.55745 3.5083L2.48202 2.95912C2.67842 2.84245 2.84245 2.67842 2.95912 2.48202L3.5083 1.55745C3.75149 1.14802 4.19026 0.894693 4.66644 0.888795L5.74173 0.875477C5.97015 0.872647 6.19422 0.812608 6.39346 0.700848L7.33135 0.174734C7.74668 -0.0582446 8.25332 -0.0582446 8.66865 0.174734L9.60654 0.700848C9.80578 0.812608 10.0298 0.872647 10.2583 0.875477L11.3336 0.888795C11.8097 0.894693 12.2485 1.14802 12.4917 1.55745L13.0409 2.48202C13.1575 2.67842 13.3216 2.84245 13.518 2.95912L14.4426 3.5083C14.852 3.75149 15.1053 4.19026 15.1112 4.66644L15.1245 5.74173C15.1274 5.97015 15.1874 6.19422 15.2992 6.39346L15.8253 7.33135C16.0582 7.74668 16.0582 8.25332 15.8253 8.66865L15.2992 9.60654C15.1874 9.80578 15.1274 10.0298 15.1245 10.2583L15.1112 11.3336C15.1053 11.8097 14.852 12.2485 14.4426 12.4917L13.518 13.0409C13.3216 13.1575 13.1575 13.3216 13.0409 13.518L12.4917 14.4426C12.2485 14.852 11.8097 15.1053 11.3336 15.1112L10.2583 15.1245C10.0298 15.1274 9.80578 15.1874 9.60654 15.2992L8.66865 15.8253C8.25332 16.0582 7.74668 16.0582 7.33135 15.8253L6.39346 15.2992C6.19422 15.1874 5.97015 15.1274 5.74173 15.1245L4.66644 15.1112C4.19026 15.1053 3.75149 14.852 3.5083 14.4426L2.95912 13.518C2.84245 13.3216 2.67842 13.1575 2.48202 13.0409ZM5.27988 10.1782C5.03729 10.4673 5.075 10.8983 5.36411 11.1409C5.65323 11.3835 6.08426 11.3458 6.32686 11.0567L10.7194 5.82183C10.962 5.53271 10.9243 5.10168 10.6352 4.85908C10.3461 4.61649 9.91505 4.6542 9.67245 4.94331L5.27988 10.1782ZM6.55002 6.55037C7.08376 6.01663 7.08376 5.15127 6.55002 4.61753C6.01629 4.08379 5.15092 4.08379 4.61718 4.61753C4.08344 5.15127 4.08344 6.01663 4.61718 6.55037C5.15092 7.08411 6.01629 7.08411 6.55002 6.55037ZM11.3821 11.3825C11.9159 10.8487 11.9159 9.98337 11.3821 9.44963C10.8484 8.91589 9.98302 8.91589 9.44929 9.44963C8.91555 9.98337 8.91555 10.8487 9.44929 11.3825C9.98302 11.9162 10.8484 11.9162 11.3821 11.3825Z" fill="#F80B00"></path>
			</svg>`;

		const id = item.dataset.variantId;

		// this needs to be changed so that it only fetches price from closest wrapper 
		let priceElem = document.querySelector(`[data-variant-id="${id}"][data-override-value]`);
		let compareElem = document.querySelector(`[data-variant-id="${id}"][data-override-compare]`);

		const pdpWrapper = item.closest(".pdp_priceWrapper");
		if (pdpWrapper) {
			priceElem = pdpWrapper.querySelector(`[data-variant-id="${id}"][data-override-value]`);
			compareElem = pdpWrapper.querySelector(`[data-variant-id="${id}"][data-override-compare]`);
		}

		if (!priceElem) return;
		
		let price = priceElem.dataset.overrideValue;
		let compare = compareElem?.dataset.overrideCompare;
		let compareHidden = false;

		if (!compare) {			
			compare = price;
			compareHidden = true;
		}

		price = Number(price);
		compare = Number(compare);

		const fromCompare = this.currentDiscount?.discount_from_compare;

		if (fromCompare && this.conditionMeet) price = compare;
		if (this.conditionMeet || oneMore) price = price * ((100 - this.currentDiscount.amount) / 100);
				
		const discountAmount = item.querySelector(".discount__amount");
		if (!discountAmount) return console.log(item, "Should have discount amount");
		
		const usePercent = discountAmount.classList.contains("discount__amount-percentage")
		let string = "", newDiscountAmount = "";	

		if (usePercent) {
			newDiscountAmount = Math.round((1 - price / compare) * 100);
			string = compareHidden && !this.conditionMeet && !oneMore ? "" : svg + newDiscountAmount + "% " + window.theme.discountsOffString;
			
		} else {
			newDiscountAmount = (compare - price);

			const bundleQuantity = discountAmount.dataset.bundleQuantity;
			if (bundleQuantity && !priceElem.classList.contains("cart__item-price")) newDiscountAmount *= Number(bundleQuantity);

			const format = window.shop_money_format.split("{{")[0] + "{{amount}}" + window.shop_money_format.split("}}")[1];
			const round = true;

			let discountAfterFormat = theme.Currency.formatMoney(newDiscountAmount, format, round);		
			discountAfterFormat = discountAfterFormat.replace(",00", "").replace(".00", "");

			string = compareHidden && !this.conditionMeet && !oneMore ? "" : svg + window.theme.discountsSaveString + " " + discountAfterFormat;
		}		
		
		if (newDiscountAmount === 0) string = "";
		discountAmount.innerHTML = string;

		if (this.currentDiscount && this.conditionMeet) item.setAttribute("data-active-discount", this.currentDiscount.code);
		else item.removeAttribute("data-active-discount");
	}
	
	setTotalPrice() {
		const totalPriceElems = document.querySelectorAll('[data-override-value][data-total-price="true"]');
		const totalCompareElems = document.querySelectorAll('[data-override-value][data-total-price="true"] + [data-override-compare]');
		
		if (!totalPriceElems || !totalPriceElems.length) return;
		const cartItems = document.querySelectorAll('#site-cart .cart-item');

		let price = 0;
		cartItems.forEach(cartItem => {
			const priceElem = cartItem.querySelector(".cart__item-price");
			const itemPrice = priceElem.dataset.priceAfterDiscount || priceElem.dataset.overrideValue;
			const quantity = cartItem.dataset.itemAmount || 1;

			price += Number(itemPrice) * quantity;
		})
		
		if (!price) price = totalPriceElems[0].dataset.overrideValue;

		totalPriceElems.forEach(elem => {
			elem.innerText = theme.Currency.formatMoney(price, window.shop_money_format);
		})

		if (!totalCompareElems) return;
		totalCompareElems.forEach(elem => {
			const compare = elem.dataset.overrideCompare;

			if (compare > price) {
				elem.innerText = theme.Currency.formatMoney(compare, window.shop_money_format);
			} else if (compare <= price) {
				elem.innerText = "";
			}
		})

	}
}

customElements.define("site-discounts", Discounts);

// discounts end

window.blockStickyHeader = false;

(function($) {

    // -----------------------------------------------------------------------------------------------
    // THEME MODIFICATIONS:
    // -----------------------------------------------------------------------------------------------

    // CURRENCY SELECTOR

 
    $(document).click(function(event) {
      var target = $(event.target);
      if (!target.closest('.header-currency-selector').length &&
          !target.closest('.sidebar-currency-selector').length &&
          !target.closest('.product-currency-selector').length) {
        $('.currency-list').each(function() {
          var el = $(this);
          if(el.is(':visible')) {
            el.hide();
            el.parent().siblings('.select').children('.chevron').toggleClass('down');
          }
        });
      }
    });

    jQuery.setCurrency = function(code) {
      $('input[name="currency"]').val(code);
      $('#currency_form').submit();
    }

    $( document ).ready(function() {
			$('.country-selector-custom').on('click', function(event) {
		
				$(this).siblings('.select-items').toggle();
				$(this).children('.chevron').toggleClass('down');
			});

		$('.currency-selector').on('click', function(event) {
			$(this).siblings('form').children('.currency-list').toggle();
			$(this).children('.chevron').toggleClass('down');
		  });
		
      $(window).scroll(function () {

          if ($(this).scrollTop()  <= 0 ){

          $(document.body).removeClass('is-scroll');
          }else{
                $(document.body).addClass('is-scroll');

          }


      });
      if(window.Weglot){
        $('.weglot_plh').show();
          $('.border-left').show();
      }

			const euCountries = window.eu_countries?.toLowerCase();
      var local = Shopify.locale;
      var local2 = Shopify.country;
			let found = false;
      $( ".select-country li" ).each(function( ) {

        var item = $(this).attr('data-country');

        if(item.toLowerCase() == local.toLowerCase()){
	
            $('.country_selected').html($(this).html());
						found = true;
        }else if(item.toLowerCase() == local2.toLowerCase() && found == false){
            $('.country_selected').html($(this).html());
						found = true;
        } else if(euCountries && (euCountries.includes(local2.toLowerCase()) || (euCountries.includes(local.toLowerCase()) && found == false))){
					$('.country_selected').html($('.select-country li[data-country="eu"]').html());

					found = true;
				} else if(found == false) {

					$('.country_selected').html($('.select-country li[data-country="wr"]').html());
				}
});

$( ".select-country li" ).on('click', function(event) {
var url = $(this).attr('data-url');
location.href = url;
});
		

    });



  
    $(document).click(function(event) {
      var target = $(event.target);
      if (!target.closest('.header-currency-selector').length &&
          !target.closest('.sidebar-currency-selector').length &&
          !target.closest('.product-currency-selector').length) {
        $('.currency-list').each(function() {
          var el = $(this);
          if(el.is(':visible')) {
            el.hide();
            el.parent().siblings('.select').children('.chevron').toggleClass('down');
          }
        });
        $('.select-items').each(function() {
          var el = $(this);
          if(el.is(':visible')) {
            el.hide();
            el.siblings('.country-selector-custom').children('.chevron').toggleClass('down');
          }
        });
      }
    });

    jQuery.setCurrency = function(code) {
      $('input[name="currency"]').val(code);
      $('#currency_form').submit();
    }





    // -----------------------------------------------------------------------------------------------
    // THEME JS STARTS HERE
    // -----------------------------------------------------------------------------------------------


	$('#site-filters select:not(.styled)').each(function(){

		$(this).styledSelect({
			coverClass: 'regular-select-cover',
			innerClass: 'regular-select-inner'
		}).addClass('styled');

		$(this).parent().append($.themeAssets.arrowDown);

		if ( $(this).data('label') != '' ) {

			if ( $(this).find('option:selected').hasClass('default') ) {
				$(this).parent().find('.regular-select-inner').html($(this).data('label'));
			}

			$(this).on('change', function(e){
				if ( $(this).find('option:selected').hasClass('default') ) {
					$(this).parent().find('.regular-select-inner').html($(this).data('label'));
				}
			});

		}

	});

	$('.site-header').append('<span id="js-helpers"><span id="fix-me-header"></span><span id="fix-me-collection"></span></span>');

	// tab navigation

	$('a:not(.ach), button, span, input').on('focus', function(e){
   	$(this).addClass('hover');
	}).on('blur', function(e){
		$(this).removeClass('hover');
	});

	$(document).keyup(function(e) {
	  if (e.keyCode === 27) {
	  	$('.site-close-handle').trigger('click');
	  }
	});

	// We start with the newsletter code (it needs to be wrapped inside a $(window).load() event function in order to get the perfect timeout after the site has completely loaded

	window.CUBER = {

		// MAIN

		Nav: {

			$siteHeader: null,
			$siteNav: null,
			$siteOverlay: null,

			mount: function() {

				this.$siteHeader = $('#site-header');
				this.$siteNav = $('#site-nav--mobile');
				this.$siteOverlay = $('#site-overlay');

				$('#site-menu-handle').on('click focusin', (function(){

					if ( ! this.$siteNav.hasClass('active') ) {

						this.$siteNav.addClass('active');
						this.$siteNav.removeClass('show-filters').removeClass('show-cart').removeClass('show-search');
						document.querySelector("cart-drawer").setAttribute("aria-expanded", false);

						this.$siteOverlay.addClass('active');

						$('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
						$('body').addClass('sidebar-move');

					}

				}).bind(this));

				if ( $('#site-filter-handle').length > 0 ) {

					$('#site-filter-handle').on('click', (function(){

						if ( ! this.$siteNav.hasClass('active') ) {

							this.$siteNav.addClass('active');
							this.$siteNav.removeClass('show-cart').removeClass('show-search').addClass('show-filters');
							document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
							this.$siteOverlay.addClass('active');

							$('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
							$('body').addClass('sidebar-move');

						}

					}).bind(this));

				}

				if ( $('#site-cart-handle').length > 0 && ! $('html').hasClass('ie9') ) {

					if ( $.themeCartSettings == 'overlay' ) {

						$('#site-cart-handle a').addClass('block-fade');

						$('#site-cart-handle a').on('click', (function(e){

							e.preventDefault();

							if ( ! this.$siteNav.hasClass('active') ) {
                  this.$siteNav.height(window.innerHeight + 'px');
								this.$siteNav.addClass('active');
								document.querySelector("cart-drawer").setAttribute("aria-expanded", true);
								
								this.$siteNav.removeClass('show-filters').removeClass('show-search').addClass('show-cart');
								this.$siteOverlay.addClass('active');
																

								$('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
								$('body').addClass('sidebar-move');
							}

						}).bind(this));

					}

					$('#site-cart-handle').on('mouseenter focusis', function(){
						$(this).addClass('hover-in').removeClass('hover-out');
					}).on('mouseleave focusout', function(){
						$(this).addClass('hover-out').removeClass('hover-in');
					});

				}

				if ( $('#site-search-handle').length > 0 ) {

					$('#site-search-handle a').addClass('block-fade');

					$('#site-search-handle a').on('click', (function(e){

						e.preventDefault();

						if ( ! this.$siteNav.hasClass('active') ) {

							if ( $('html').hasClass('ie9') ) {
								document.location.href = '/search';
							} else {
								this.$siteNav.addClass('active');
								this.$siteNav.removeClass('show-filters').removeClass('show-cart').addClass('show-search');
								document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
								this.$siteOverlay.addClass('active');

								$('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
								$('body').addClass('sidebar-move');

								$('form.search-bar input[type="search"]').focus();
							}

						}

					}).bind(this));

					$('#site-search-handle').on('mouseenter', function(){
						$(this).addClass('hover-in').removeClass('hover-out');
					}).on('mouseleave focusout', function(){
						$(this).addClass('hover-out').removeClass('hover-in');
					});

					$('a[href="#search"]').on('click', function(e){
						e.preventDefault();
						$('#site-search-handle a').trigger('click');
					})

				}

				$('.site-close-handle, #site-overlay').on('click', (function(){
	
					if ( this.$siteNav.hasClass('active') ) {

						this.$siteNav.removeClass('active');

						document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
						this.$siteOverlay.removeClass('active');

						$('.fixing-scroll-now .site-box-background').removeClass('sidebar-move');
						$('body').removeClass('sidebar-move');

					}

				}).bind(this));

				///

				$('.site-nav.style--classic .has-submenu').each(function(){
					$(this).on('mouseenter focusin', function(){
						$(this).find('.submenu').stop().slideDown(200);
						$('body').addClass('opened-submenu');
						$('body').addClass('opened-submenu-flag');
						$('.site-overlay').addClass('active');
						$(this).find('.submenu').attr('aria-expanded', 'true');
					}).on('mouseleave focusout', function(){
						$(this).find('.submenu').attr('aria-expanded', 'false');
						$(this).find('.submenu').stop().slideUp(200, function(){
							if ( ! $('body').hasClass('opened-submenu-flag') ) {
								$('body').removeClass('opened-submenu');
							}
						});
						$('.site-overlay').removeClass('active');
						$('body').removeClass('opened-submenu-flag');
					})
				})

				$('.site-nav.style--sidebar .has-submenu:not(.collections-menu)').each(function(){

					$(this).children('a').addClass('block-fade');
					$(this).children('a').on('click touchstart', function(e) {
						e.preventDefault();
					})

					$(this).children('a').on('click touchstart', function(e){

						e.preventDefault();
						var $parent = $(this).parent();

						if ( $parent.hasClass('active') ) {

							var tempBoNo = false;
							var tempBoHref = $(this).attr('href');

							if ( tempBoHref != '' ) {

								if ( tempBoHref.indexOf('#') >= 0 ) {

									tempBoNo = true;

									if ( tempBoHref.indexOf('#') == ( tempBoHref.length-1 ) ) {
										// nothing
									} else {
		  							$('.site-close-handle').trigger('click');
				    				document.location.href = tempBoHref;
									}

								} else if ( $(this).attr('target') == '_blank' ) {

									window.open(tempBoHref, '_blank');

								} else {

				    			$('body').fadeOut(200);
				    			setTimeout((function(){
				    				document.location.href = tempBoHref;
				    			}).bind(this), 200);
				    			e.preventDefault();

								}

							} else {
								tempBoNo = true;
							}

							if ( tempBoNo ) {
								$parent.find('.submenu').stop().slideUp(200);
								$parent.removeClass('active');
								$parent.find('.submenu').attr('aria-expanded', 'false');
							}

						} else {
							$parent.addClass('active');
							$parent.find('.submenu').stop().slideDown(200);
							$parent.find('.submenu').attr('aria-expanded', 'true');
						}

						$(this).removeClass('hover');

					})

				})

				$('.site-nav.style--sidebar .has-babymenu:not(.collections-menu)').each(function(){

					$(this).children('a').addClass('block-fade');
					$(this).children('a').on('click touchstart', function(e) {
						e.preventDefault();
					})

					$(this).children('a').on('click touchstart', function(e){

						e.preventDefault();
						var $parent = $(this).parent();

						if ( $parent.hasClass('active') ) {

							var tempBoNo = false;
							var tempBoHref = $(this).attr('href');

							if ( tempBoHref != '' ) {

								if ( tempBoHref.indexOf('#') >= 0 ) {

									tempBoNo = true;

									if ( tempBoHref.indexOf('#') == ( tempBoHref.length-1 ) ) {
										// nothing
									} else {
		  							$('.site-close-handle').trigger('click');
				    				document.location.href = tempBoHref;
									}

								} else if ( $(this).attr('target') == '_blank' ) {

									window.open(tempBoHref, '_blank');

								} else {

				    			$('body').fadeOut(200);
				    			setTimeout((function(){
				    				document.location.href =tempBoHref
				    			}).bind(this), 200);
				    			e.preventDefault();

								}

							} else {
								TempBoNo = true;
							}

							if ( tempBoNo) {
								$parent.removeClass('active');
								$parent.find('.babymenu').stop().slideUp(200);
								$parent.find('.babymenu').attr('aria-expanded', 'false');
							}

						} else {
							$parent.addClass('active');
							$parent.find('.babymenu').stop().slideDown(200);
							$parent.find('.babymenu').attr('aria-expanded', 'true');
						}

					})

				})

				$('.style--classic .babymenu').each(function(){

					var bestWidth = 0;
					$(this).parent().parent().css('display', 'block');

					$(this).find('a').each(function(){
						$(this).css('position', 'fixed');
						$(this).attr('data-width', $(this).outerWidth(true))
						if ( $(this).outerWidth() > bestWidth ) {
							bestWidth = $(this).outerWidth(true);
						}
						$(this).css({'position': 'static', 'width': '100%'});
					});

					bestWidth += 30;
					$(this).css('width', bestWidth);
					$(this).css('transform', 'translateX(-45%)');
					$(this).parent().parent().css('display', 'none');
					$(this).css('display', 'none');

				});

				$('.style--classic .has-babymenu').each(function(){
					$(this).on('mouseenter focusin', function(){
						$(this).find('.babymenu').stop().slideDown(200);
						$(this).find('.babymenu ul').attr('aria-expanded', 'true');
						$(this).css('zIndex', 9);
					}).on('mouseleave focusout', function(){
						$(this).find('.babymenu').stop().slideUp(200);
						$(this).find('.babymenu ul').attr('aria-expanded', 'false');
						$(this).css('zIndex', 1);
					});
				});

				///

				$('body').addClass('desktop--add-some-padding');

				$('.style--classic li.has-submenu[data-size]').each(function(){
					var menuSize = parseInt( $(this).data('size') )
					if ( menuSize > 15 ) {
						$(this).addClass('text-smallest');
					} else if ( menuSize > 10 ) {
						$(this).addClass('text-smaller');
					} else if ( menuSize > 5 ) {
						$(this).addClass('text-small');
					}
				});

				// end -- */

				if ( $('#site-header').hasClass('header-scroll') ) {

					if ( $('body').hasClass('template-index') ) {
						$('body').addClass('index-margin-fix');
					}

					window.lst = $(window).scrollTop();

					$('.site-nav.style--classic .submenu').css('top', $('.site-header').outerHeight())

					$(window).on('scroll.sticky-header', (function(){

						if ( ! window.blockStickyHeader ) {

			        var st = $(window).scrollTop();

			        if ( st < 0 || Math.abs(lst - st) <= 5 )
			          return;

			       	if ( st < 20) {

								this.$siteHeader.removeClass('animate');
								this.$siteHeader.removeClass('fix');
								this.$siteHeader.removeClass('ready');
                this.$siteHeader.addClass('special_placemenet');
								//$('body').css('paddingTop', 0);

			       	} else if ( st <= lst && ! this.$siteHeader.hasClass('fix') ) {

								this.$siteHeader.addClass('fix');
								//$('body').css('paddingTop', this.$siteHeader.outerHeight());
								setTimeout((function(){
									this.$siteHeader.addClass('ready');
                      this.$siteHeader.removeClass('special_placemenet');
								}).bind(this), 5);
								setTimeout((function(){
									this.$siteHeader.addClass('animate');
								}).bind(this), 25);

							} else if ( st > lst && this.$siteHeader.hasClass('animate') ) {

								this.$siteHeader.removeClass('animate');
								setTimeout((function(){
									this.$siteHeader.removeClass('fix');
									this.$siteHeader.removeClass('ready');
                      this.$siteHeader.addClass('special_placemenet');
									//$('body').css('paddingTop', 0);
								}).bind(this), 105);

							}

							window.lst = st;

						}

					}).bind(this));

				}

			},

			unmount: function() {

				$('#site-menu-handle').off('click');
				$('#site-cart-handle a').off('click');
				$('#site-filter-handle').off('click');

				this.$siteNav.removeClass('active');
				document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
				this.$siteOverlay.removeClass('active');

				$('.fixing-scroll-now .site-box-background').removeClass('sidebar-move');
				$('body').removeClass('sidebar-move');

				$(window).off('scroll.sticky-header');

			}

		},

		// COLLECTION

		Collection: {

			$collectionGrid: null,
			$collectionNext: null,
			$collectionNextLink: null,

			mount: function() {

				if ( $('.box__paginate').length > 0 ) {

					this.$collectionGrid = $('#section-collection');
					this.$collectionNext = $('.box__paginate');
					this.$collectionNextLink = $('.box__paginate a');

					this.$collectionNextLink.append('<div class="preloader"><span>.</span><span>.</span><span>.</span></div>')

					this.$collectionNextLink.on('click', (function(e){

						this.$collectionNextLink.addClass('loading');
						var nextPageURL = this.$collectionNextLink.attr('href');

						$.ajax({
							url: nextPageURL
						}).done((function(data){

							this.$collectionNextLink.removeClass('loading');
							this.$collectionNext.before($(data).find('.site-box.box__collection'));
							//window.CUBER.Images.mount();

							var i = 0;
							this.$collectionGrid.find('.box__collection:not(.active)').each(function(){
								setTimeout((function(){
									$(this).addClass('active');
								}).bind(this), 100*i++);
							});

							if ( $(data).find('.site-box.box__paginate').length > 0 ) {
								this.$collectionNextLink.attr('href', $(data).find('.site-box.box__paginate a').attr('href'));
							} else {
								this.$collectionNext.remove();
							}

						}).bind(this));

						e.preventDefault();

					}).bind(this));

				}

				$(window).on('resize.collection-grid', window.debounce((function(){
					this._resizeCollection();
				}).bind(this), 300)).trigger('resize.collection-grid');
				this._resizeCollection();
				setTimeout((function(){
					this._resizeCollection();
				}).bind(this), 1001);

				// empty grid fix

				var collectionSize =  parseInt($('.box__heading').data('size'));

				if ( collectionSize > 0 && collectionSize < 4 ) {
					for ( var i = 0; i < 4 - collectionSize; i++ ) {
						$('#section-collection').append('<div class="site-box box--small box--typo-small lap--hide box--no-padding box__collection active" />');
					}
				}

			},

			_resizeCollection: function() {


				if ( $('#fix-me-header').css('display') == 'block' && $('#fix-me-collection').css('display') == 'block' ) {

					var wh = $(window).height();
					var h = wh - $('.site-header').outerHeight();

					if ( h > 720 ) {

						//$('.mount-products .site-box.box__heading').attr('style', 'height:' + h + 'px !important; min-height: 0 !important;');
						$('.mount-products .site-box.box__collection_image').attr('style', 'height:' + h + 'px !important; min-height: 0 !important;');

					} else {

						h = 720;

						if ( $('.mount-products .site-box.box__collection_image').length > 0 ) {
							$('.mount-products .site-box.box__heading').attr('style', 'height:' + ( wh - $('.site-header').outerHeight() ) + 'px !important; min-height: 0 !important;');
							$('.mount-products .site-box.box__collection_image').attr('style', 'height:' + ( wh - $('.site-header').outerHeight() ) + 'px !important; min-height: 0 !important;');
						}


					}

				} else {

					$('.mount-products .site-box.box__collection, .mount-products .site-box.box__heading').attr('style', '');

				}

			},

			unmount: function() {
				$(window).off('resize.collection-grid');
			}

		},

		// PRODUCT

		Product: {

			$productGallery: null,
			$productGalleryItem: null,
			$productGalleryIndex: null,

			$productCarousel: null,
			$productCarouselImgs: null,
			productFlkty: null,

			$productStuff: null,
			productStuffMove: false,

			mount: function($product) {				
				var productIsDisabled = false;

				if ( $product.find('.product--section').data('hide-variants') && $product.find('.product--section').data('product-available') ) {
					this._advancedOptionsSelector($product, JSON.parse($product.find('.product-json')[0].innerHTML));
				} else if ( $product.find('.product--section').data('hide-variants') && ! $product.find('.product--section').data('product-available') ) {
					productIsDisabled = true;
				}

				// Product gallery
        		new Dropdown(document.querySelector('.Dropdown'));
				var _this = {};
				$product.data('po', _this);

				_this.$productGallery = $product.find('.box__product-gallery');
				_this.$productGalleryItem = $product.find('.box__product-gallery .gallery-item');

				_this.$productGallery.append('<div class="gallery-index out-with-you"><span class="current">' + ( window.CuberProductImageIndex != undefined ? ( window.CuberProductImageIndex + 1 ) : 1 ) + '</span> / <span class="total">' + _this.$productGalleryItem.length + '</span></div>');
				_this.$productGalleryIndex = _this.$productGallery.find('.gallery-index .current');

				_this.$productCarousel = _this.$productGallery.children('.site-box-content');

				window.CUBER.Main._mountScrollMovers({
					'parent': _this.$productGallery,
					'items': $('.gallery-index, .site-sharing, .product-zoom')
				});

				window.CUBER.Main._mobileSharingInit();

				if ( _this.$productGallery.hasClass('scroll') ) {

					// init scrollable gallery

					$(window).on('scroll.product-gallery', (function() {

						if ( ! _this.$productCarousel.hasClass('flickity-enabled') ) {

							_this.$productGalleryItem.each((function(key, elm){

								if ( $(window).scrollTop() + $(window).height() > $(elm).offset().top + $(window).height() / 2 && ! $(elm).hasClass('current') ) {

									$(elm).addClass('current');
									_this.$productGalleryIndex.html($(elm).index() + 1);

								} else if ( $(window).scrollTop() + $(window).height() < $(elm).offset().top + $(window).height() / 2 && $(elm).hasClass('current') ) {

									$(elm).removeClass('current');
									_this.$productGalleryIndex.html($(elm).index());

								}

							}).bind(_this));

						}

					}).bind(_this)).trigger('scroll.product-gallery');

				}

				// init sliding gallery (always, because it turns into this at responsive)

				_this.$productCarousel.flickity({
					cellSelector: '.gallery-item:not(.remove-from-flick)',
					initialIndex: window.CuberProductImageIndex != undefined ? window.CuberProductImageIndex : 0,
					wrapAround: true,
					prevNextButtons: false,
					pageDots: true,
					watchCSS: _this.$productGallery.hasClass('scroll') ? true : false,
					resize: true
				});

				window.CUBER.Scroll.mount();

				_this.productFlkty = _this.$productCarousel.data('flickity');
				_this.$productCarouselImgs = _this.$productCarousel.find('.gallery-item img');

				_this.$productCarousel.on('select.flickity', (function(){
					_this.$productGalleryIndex.html((_this.productFlkty.selectedIndex+1));
				}).bind(_this))

				if ( _this.$productGallery.hasClass('slider') ) {

					_this.$productGallery.find('.gallery-index').append('<span class="icon-go go-prev">' + $.themeAssets.arrowRight + '</span><span class="icon-go go-next">' + $.themeAssets.arrowRight + '</span>');

					_this.$productGallery.find('.go-prev').on('click', (function(){
						_this.productFlkty.previous();
					}).bind(_this));

					_this.$productGallery.find('.go-next').on('click', (function(){
						_this.productFlkty.next();
					}).bind(_this));

				}

				// Product zoom

				if ( $('#product-zoom-in').length > 0 ) {

					$('body').append('<div id="product-zoomed-image"><img /><div id="product-zoom-out" class="product-zoom expand"><span class="zoom-out">' + $.themeAssets.iconZoom + '</span></div></div>');

					$('#product-zoom-in').on('click', (function(e){

						// animation out

						$('#section-product').find('.site-box.box__product-content').addClass('animate');
						setTimeout(function(){
							$('#section-product').find('.site-box.box__product-content').addClass('expand');
							$('body').addClass('kill-overflow');
						}, 10);

						$('#section-product').find('.site-box.box__product-gallery').stop().animate({'opacity': 0}, 200);
						$('#shopify-section-header, #shopify-section-footer, .site-sharing').stop().animate({'opacity': 0}, 200);

						// object

						var $image = $('#product-zoomed-image img');
						$image.attr('src', $('.gallery-item').eq(parseInt(_this.$productGalleryIndex.html())-1).data('master'));

						setTimeout((function(){
							if ( $image[0].naturalWidth > 0 ) {
									this._productZoomMount($image);
							} else {
								$image.on('load', (function(){
									this._productZoomMount($image);
								}).bind(this))
							}
						}).bind(this), 200);

					}).bind(this));

					$('#product-zoom-out').on('click', (function(e){

						setTimeout(function(){

							// animation out

							$('#section-product').find('.site-box.box__product-content').removeClass('expand');
							$('body').removeClass('kill-overflow')
							setTimeout(function(){
								$('#section-product').find('.site-box.box__product-content').removeClass('animate');
							}, 400);

							$('#section-product').find('.site-box.box__product-gallery').stop().animate({'opacity': 1}, 200);
							$('#shopify-section-header, #shopify-section-footer, .site-sharing').stop().animate({'opacity': 1}, 200);

						}, 150);

						// object

						this._productZoomUnmount();

					}).bind(this));

				}

				// Add to cart (& ajax)

				if ( ! $product.find('.product--section').hasClass('onboarding-true') ) {
					this.initProductForm($product, productIsDisabled);
				}

				if ( $product.find('.qty-button').length > 0 ) {

					var $productQty = $product.find('.quantity-selector');

					if ( parseInt($productQty.val()) - 1 < parseInt($productQty.attr('min')) ) {
						$product.find('.qty-minus').addClass('disabled');
					}
					if ( parseInt($productQty.val()) + 1 > parseInt($productQty.attr('max')) ) {
						$product.find('.qty-plus').addClass('disabled');
					}

					$product.find('.qty-minus').on('click', (function($productQty, $productQtyPlus, e){
						if ( ! $(e.target).hasClass('disabled') ) {
							var currentQty = parseInt($productQty.val());
							if ( currentQty - 1 >= parseInt( $productQty.attr('min') ) ) {
								$productQty.val(currentQty - 1);
								$productQtyPlus.removeClass('disabled');
							}
							if ( currentQty - 1 <= parseInt( $productQty.attr('min') ) ) {
								$(e.target).addClass('disabled');
							}
						}
						e.preventDefault();
					}).bind(this, $productQty, $product.find('.qty-plus')));

					$product.find('.qty-plus').on('click', (function($productQty, $productQtyMinus, e){
						if ( ! $(e.target).hasClass('disabled') ) {
							var currentQty = parseInt($productQty.val());
							if ( currentQty + 1 <= parseInt( $productQty.attr('max') ) ) {
								$productQty.val(currentQty + 1);
								$productQtyMinus.removeClass('disabled');
							}
							if ( currentQty + 1 >= parseInt( $productQty.attr('max') ) ) {
								$(e.target).addClass('disabled');
							}
						}
						e.preventDefault();
					}).bind(this, $productQty, $product.find('.qty-minus')));

				}

				if ( $product.find('.product--add-to-cart-form').length > 0 && $product.find('.product--add-to-cart-form').data('type') == 'overlay' && ! $('html').hasClass('ie9') ) {

					var $form = $product.find('.product--add-to-cart-form form'),
					  	$submitText = $form.find('.add-to-cart-text'),
					  	$submitButton = $form.find('button[type="submit"]'),
					  	$cartCount = $('.cart-menu .count'),
					  	$cartQty = $product.find('.quantity-selector');

			  		if ( $form.attr('action').indexOf('.js') < 0 ) {
			  			$form.attr('action', $form.attr('action') + '.js');
			  		}

			  	$form.submit(function(e){

			  		e.preventDefault();

			  		var oldText = $submitText.html();
			  		$submitText.html('<span class="preloader"><span>.</span><span>.</span><span>.</span></span>');
			  		$submitButton.css('pointer-events', 'none');

			  		var itemName = $product.find('.product-title').text(),
			  				itemPrice = $product.find('.product-price').attr('data-price'),
			  				itemCurrency = $('meta[itemprop="priceCurrency"]').attr('content'),
			  				itemId = $product.find('.product--section').data('id');

			  		$.ajax({

			  			type: $form.prop('method'),
			  			url: $form.prop('action'),
			  			data: $form.serialize(),
			  			dataType: 'json',
			  			success: function(data){

			  				setTimeout(function(){
			  					$submitText.html(oldText);
			  					$submitButton.css('pointer-events', 'all');
			  				}, 500);

			  				$.ajax({
			  					url: `${window.routes.localeRootUrl}/cart`,
			  					success: function(data) {

			  						if ( typeof fbq !== 'undefined' ) {
  										fbq('track', 'AddToCart', {
									      content_name: itemName,
									      content_ids: [itemId],
									      content_type: 'product_group',
									      value: itemPrice,
									      currency: itemCurrency
  										});
			  						}
                    this.$siteHeader = $('#site-header');
                    this.$siteNav = $('#site-nav--mobile');
                    this.$siteOverlay = $('#site-overlay');

                      var cartData = $(data).find('cart-drawer');
                    $('#site-cart').html( cartData[0]);
                    event.preventDefault();
                    var quantity = parseInt($(data).find('.CartMain').attr('data-quantity-total'));
                     window.theme.cartCount = quantity;
                                     if(quantity){
            $(".count").html(quantity);
       }
	   
			e.target.dispatchEvent(
				new CustomEvent("refresh:discount", {
					bubbles: true
				})
				);
                     
											 document.dispatchEvent(
												new CustomEvent("total:changed", {
													bubbles: true
												})
												);
												
							document.querySelector('cart-drawer').style.maxHeight = window.innerHeight + 'px';
                    if ( ! this.$siteNav.hasClass('active') ) {

                      this.$siteNav.addClass('active');
                      this.$siteNav.removeClass('show-filters').removeClass('show-search').addClass('show-cart');
						document.querySelector("cart-drawer").setAttribute("aria-expanded", true);

                      this.$siteOverlay.addClass('active');
					 
                      $('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
                      $('body').addClass('sidebar-move');
					  
						  const _this = this;
						  setTimeout(() => {
							$('.site-close-handle, #site-overlay').on('click', (function(){
								document.querySelector('cart-drawer').style.maxHeight = window.innerHeight + 'px';
								_this.$siteHeader = $('#site-header');
								_this.$siteNav = $('#site-nav--mobile');
								_this.$siteOverlay = $('#site-overlay');
								if ( _this.$siteNav.hasClass('active') ) {
									
									_this.$siteNav.removeClass('active');
									document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
									_this.$siteOverlay.removeClass('active');
			
									$('.fixing-scroll-now .site-box-background').removeClass('sidebar-move');
									$('body').removeClass('sidebar-move');
			
								}
			
							}).bind(this));
							document.dispatchEvent(
								new CustomEvent("total:changed", {
									bubbles: true
								})
								);
						  }, "200")
						
                    }
			  					}
			  				});

			  			},

			  			error: function(data) {

			  				alert(data.responseJSON.description);

			  				setTimeout(function(){
			  					$submitText.html(oldText);
			  					$submitButton.css('pointer-events', 'all');
			  				}, 100);

			  			}

			  		});

			  	});

				}

			},

			_productZoomMount: function( $image ) {

				$('#product-zoomed-image').css('display', 'block');
				$image.css({'left': 0, 'top': 0});

				$(window).on('mousemove.product-zoom', function(e) {
					e.preventDefault();
					window.clientX = e.clientX;
					window.clientY = e.clientY;
					var x = e.clientX * ( $(window).width() - $image.width() ) / $(window).width();
					var y = e.clientY * ( $(window).height() - $image.height() ) / $(window).height();

					$image.css({'left': x, 'top': y});
				});

				if ( $image[0].naturalWidth <= $image[0].naturalHeight ) {
					$image.addClass('portrait');
				} else {
					$image.addClass('landscape');
				}
				$image.data('ratio', $image[0].naturalWidth / $image[0].naturalHeight);

				$(window).on('resize.product-zoom', function(){

					var rf = $(window).width() > 768 ? 1 : 2;

					if ( $image.hasClass('portrait') ) {
						$image.css('width', $(window).width()*rf);
						$image.css('height', $(window).width()*rf / $image.data('ratio'));
					} else {

						$image.css('height', $(window).height()*rf);
						$image.css('width', $(window).height()*rf * $image.data('ratio'));

						if ( $image.width() < $(window).width() ) {
							$image.css('width', $(window).width()*rf);
							$image.css('height', $(window).width()*rf / $image.data('ratio'));
						}

					}

					var x = window.clientX * ( $(window).width() - $image.width() ) / $(window).width();
					var y = window.clientY * ( $(window).height() - $image.height() ) / $(window).height();

					//$image.css({'left': x, 'top': y});

				}).trigger('resize');

				$image.css('opacity', 1);

			},

			_productZoomUnmount: function() {

				$('#product-zoomed-image img').css('opacity', '0');

				setTimeout(function(){
					$(window).off('resize.product-zoom');
					$(window).off('mousemove.product-zoom');
					$('#product-zoomed-image img').attr('src', '');
					$('#product-zoomed-image').css('display', 'none');
				}, 300);

			},

			initProductForm : function( $product, pdisabled ) {

				var firstVariantEver = true;

				var productSingleObject = JSON.parse($product.find('.product-json')[0].innerHTML),
						productVariants = productSingleObject.variants;

				$product.find('form select.product-variants').on('change', (function(e){
					this._initProductVariantChange(false, productSingleObject, $product);
				}).bind(this));

				this._initProductVariantChange(true, productSingleObject, $product);

				if ( $product.find('.product--add-to-cart-form').hasClass('style--classic') ) {

					$product.find('select.product-variants:not(.styled)').each(function(){

						$(this).styledSelect({
						  coverClass: 'regular-select-cover',
						  innerClass: 'regular-select-inner'
						}).addClass('styled');

					 	$(this).parent().append($.themeAssets.arrowDown);

				 	 	$(this).on('focusin', function(){
				 	 		$(this).parent().addClass('focus');
				 	 	}).on('focusout', function(){
				 	 		$(this).parent().removeClass('focus');
				 	 	});

					});

					$product.find('.product-variant').removeClass('hidden');

					if ( pdisabled ) {
						$product.find('.product-variant').css('display', 'none');
					}

				} else {

					var i = 1;

					$product.find('.product-variant').each(function(j){

						var color = window.returnColorVariant($(this).find('label').text()) ? true : false,
								varDOM = '<ul class="color-' + color + '" data-option="option' + (j+1) + '">';

						$(this).find('.product-variants option').each(function(){
							varDOM += '<li' + ( $(this).is(':selected') ? ' class="active"' : '' ) + ' tabindex="0" data-text="' + $(this).val() + '"><span' + ( color ? ' style="background-color: ' + $(this).val().split(' ').pop() + '"' : '' ) + '>' + $(this).val() + '</span></li>';
						});

						varDOM += '</ul>';
						$(this).find('select').hide();
						$(this).append(varDOM);

						$(this).removeClass('hidden');

						$(this).find('ul li').on('click', function(){
							$(this).parent().parent().find('select').val($(this).find('span').text()).change();
						});

						$(this).find('ul li').on('keyup', function(e){
							if ( e.keyCode == 13 ) {
								$(this).parent().parent().find('select').val($(this).find('span').text()).change();
							}
						});

					});

					if ( pdisabled ) {
				 		$product.find('.product-variant').find('li').addClass('disabled');
					}

				}

				if ( productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.indexOf('Default') >= 0 ) {
					$product.find('.product-variant').hide();
				}

			},

			_getProductVariant : function( $product ) {

				/* ----
					Get current variant
					---- */

				var optionArray = [];

				$product.find('form select.product-variants').each(function(){
					optionArray.push($(this).find(':selected').val())
				});

				return optionArray;

			},

			_initProductVariantChange : function(firstTime, productSingleObject, $product) {

				var variant = null,
					options = this._getProductVariant( $product );

				productSingleObject.variants.forEach(function(el){

					if ( $(el)[0].options.equals(options) ) {
						variant = $(el)[0];
					}

				});

				this._productSelectCallback(variant, $product, productSingleObject);

				if ( ! firstTime && $product.find('#productSelect option').length > 1 && ! $('body').hasClass('template-index') ) {
					this._updateProductVariantState(variant);
				}

			},

			_updateProductVariantState : function(variant) {

			   if (!history.pushState || !variant) {
			    return;
			  }

			  var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
			  window.history.replaceState({path: newurl}, '', newurl);

			},

			_productSelectCallback : function(variant, $product, productSingleObject) {

				var _po = $product.data('po');

				var $addToCart = $product.find('.product--add-to-cart-form'),
						$addToCartButton = $addToCart.find('button[type="submit"]'),
			      $productPrice = $product.find('.product-price'),
			      $comparePrice = $product.find('.compare-price'),
			      $quantityElements = $product.find('.quantity-selector, label + .js-qty'),
			      $quantityElementsHolder = $product.find('.quantity-selector-holder'),
			      $addToCartText = $product.find('.add-to-cart-text'),
			      $productGallery = $product.find('.box__product-gallery');

				if (variant) {

					// Set cart value id

					$product.find('#productSelect').find('option[value="' + variant.id + '"]').prop('selected', true);

					// Swipe to variant slide

					if ( variant.featured_image != null ) {

						var variantImg = $productGallery.find('.gallery-item[data-variant-img="' + variant.featured_image.id + '"]');

						if ( typeof VIG !== 'undefined' ) {

							VIG.switchImages(productSingleObject.id, variant.id, '.box__product-gallery .site-box-content');

							if ( $product.find('.box__product-gallery .site-box-content').hasClass('flickity-enabled') ) {

								setTimeout(function(){

									$product.find('.box__product-gallery .gallery-item').each(function(){
										$(this).removeClass('remove-from-flick');
										if ( $(this).css('display') == 'none' ) {
											$(this).addClass('remove-from-flick');
										}
									})

									_po.productFlkty.reloadCells();
									_po.productFlkty.reposition();

								}, 1000);

							}

						} else if ( $productGallery.hasClass('scroll') && variantImg.length > 0 && $(window).width() > 1024 ) {

								if ( $(window).scrollTop() > 0 ) {
									$('html, body').stop().animate({'scrollTop': $productGallery.offset().top}, 150, function(){
										$(window).off('scroll.to-junk');
									})
								}

							variantImg.prependTo($product.find('.box__product-gallery .site-box-content'))

						} else if ( _po != undefined && variantImg.length > 0 ) {
							if ( _po.productFlkty != undefined && variantImg.data('index') != _po.productFlkty.selectedElement ) {
								_po.productFlkty.select(variantImg.data('index'));
							} else {
								window.CuberProductImageIndex = variantImg.data('index');
							}
						}

					}

					// Disable other variants

					if ( $addToCart.hasClass('style--minimal') ) {
						$product.find('.product-variant ul').each(function(){
							var option = variant[$(this).data('option')];
							$(this).find('li').each(function(){
								$(this).removeClass('active');
								if ( option == $(this).data('text') ) {
									$(this).addClass('active');
								}
							});
						})
					}

					// Edit cart buttons based on stock

					var $variantQuantity = $product.find('.variant-quantity');

					if ( variant.available ) {

						$quantityElements.prop('max', 999);
						$addToCartButton.removeClass('disabled').prop('disabled', false);
						$addToCartText.text($('body').hasClass('template-product-pre-order') ? $addToCartText.data('text') : window.product_words_add_to_cart_button);
						$variantQuantity.text($('body').hasClass('template-product-pre-order') ? $variantQuantity.data('text') : '');
						$quantityElements.show();
						if ( $quantityElementsHolder != null ) {
							$quantityElementsHolder.show();
						}

					} else {

						$variantQuantity.text(window.product_words_no_products);
						$addToCartButton.addClass('disabled').prop('disabled', true);
						$addToCartText.text(window.product_words_sold_out_variant);
						$quantityElements.hide();
						if ( $quantityElementsHolder != null ) {
							$quantityElementsHolder.hide();
						}

					}

					// Update price

					$productPrice.html( theme.Currency.formatMoney(variant.price, window.shop_money_format) );
					$productPrice.attr( 'data-price', variant.price / 100 );
					if ( variant.compare_at_price > variant.price ) {
						$comparePrice.html(theme.Currency.formatMoney(variant.compare_at_price, window.shop_money_format)).show();
					} else {
					//	$comparePrice.hide();
					}

					// Update sku
 
					if ( $product.find('.variant-sku').length > 0 ) {
						if ( variant ) {
							$product.find('.variant-sku').text(variant.sku);
						} else {
							$product.find('.variant-sku').empty();
						}
					}

				} else {

					// Disable variant completely

					$addToCartButton.addClass('disabled').prop('disabled', true);
					$addToCartText.text(window.product_words_unavailable_variant);
					$quantityElements.hide();
					if ( $quantityElementsHolder != null ) {
						$quantityElementsHolder.hide();
					}

				}

				if ( $product.find('.qty-button').length > 0 ) {

					var $productQty = $product.find('.quantity-selector');
					$product.find('.qty-minus').removeClass('disabled');
					$product.find('.qty-plus').removeClass('disabled');

					if ( parseInt($productQty.val()) - 1 < parseInt($productQty.attr('min')) ) {
						$product.find('.qty-minus').addClass('disabled');
					}
					if ( parseInt($productQty.val()) + 1 > parseInt($productQty.attr('max')) ) {
						$product.find('.qty-plus').addClass('disabled');
					}

				}

			},

			_advancedOptionsSelector: function($product, productJson) {
			  var om = {};
			  $product.data('om', om);
			  var forceMutation = false;
			  var $addToCartForm = $product.find('.product--add-to-cart-form');
			  if (window.MutationObserver && $addToCartForm.length) {
			    if (typeof observer === 'object' && typeof observer.disconnect === 'function') {
			      observer.disconnect();
			    }
			    var config = { childList: true, subtree: true };
			    var observer = new MutationObserver(function() {
			      Shopify.linkOptionSelectors(productJson, $product);
			      observer.disconnect();
			    });
			    if ( forceMutation ) {
			      Shopify.linkOptionSelectors(productJson, $product);
			    }
			    observer.observe($addToCartForm[0], config);
			  }
			},

			unmount: function($product) {
				var po = $product.data('po');
				$(window).off('scroll.product-gallery');
				$(window).off('resize.position-product-zoom');
				po.$productCarousel.off('scroll.flickity');
				po.$productCarousel.off('select.flickity');
				po.productFlkty.destroy();
				$('#product-zoom').off('click');
			}

		},

		Main: {

			$searchForm: null,
			$searchResults: null,
			$searchPreloader: null,
			$searchPagination: null,

			$body: null,
			$siteHeader: null,
			$siteFooter: null,

			$siteBoxes: null,

			_mountScrollMovers: function(props) {

				var $parent = props['parent'],
						parentOutOfFocus = false;

				setTimeout(function(){
					props['items'].removeClass('out-with-you');
				}, 1000);
				props['items'].addClass('animate-owy');

				$(window).on('scroll.scroll-movers', (function(){

					/*if ( ! parentOutOfFocus && $(window).scrollTop() + $(window).height() < $parent.offset().top ) {

						// before element
						props['items'].addClass('out-with-you');
						parentOutOfFocus = true;

					} else */if ( ! parentOutOfFocus && $(window).scrollTop() + $(window).height() > $parent.offset().top + $parent.height() ) {

						// after element
						props['items'].addClass('out-with-you');
						parentOutOfFocus = true;

					} else if ( parentOutOfFocus && $(window).scrollTop() + $(window).height() <= $parent.offset().top + $parent.height() ) {

						// within element
						parentOutOfFocus = false;
						props['items'].removeClass('out-with-you');

					}

				}).bind(this));

			},

			_mobileSharingInit: function() {

				$('.touchevents .site-sharing .icon').on('touchstart', function(e){

					e.preventDefault();
					var $parent = $(this).parent();

					if ( $parent.hasClass('hover') ) {
						$parent.removeClass('hover');
					} else {
						$parent.addClass('hover');
					}

				});

				$('.touchevents .site-sharing a').on('touchstart', function(e){
					$(this).parent().removeClass('hover');
				});

			},

			_resizeEverything: function() {
        const width = $(window).width();
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;

        if ( window.location.pathname == '/' || window.location.pathname == 'en-gb' ){

     } else {
     $element = $('.main-content');
     $element.css('paddingTop', this.$siteHeader.outerHeight());
     }
				if ( this.$body.hasClass('template-index') ) {

					if ( $('#fix-me-header').css('display') == 'block' ) {

						if ( $('.mount-slideshow').children('div').length > 0 ) {

							$('#shopify-section-home_slideshow').css('marginTop', -this.$siteHeader.outerHeight());
							$('.fix-me-with-margin').css('marginTop', this.$siteHeader.outerHeight());

						} else {

							$('.index-section:first-child .fix-me-with-margin').css('marginTop', -this.$siteHeader.outerHeight());
							$('.index-section:first-child .fix-me-with-height').css('height', $(window).height() - this.$siteHeader.outerHeight());

						}

					} else {

						if ( $('.mount-slideshow').children('div').length > 0 ) {

							$('#shopify-section-home_slideshow').css('marginTop', '0');
							$('.slideshow-item:first-child .site-box-content').css('marginTop', '0');

						}

					}

				} else {

					if ( $('#fix-me-header').css('display') == 'block' ) {

						$('.fix-me-with-margin').each((function(key, elm){
							if ( $(elm).outerHeight() < $(window).height() ) {
								$(elm).css('marginTop', -this.$siteHeader.outerHeight())
							} else {
								$(elm).css('marginTop', '0')
							}
						}).bind(this));

						$('.fix-me-with-height-hard').css({
							'height': $(window).height() - this.$siteHeader.outerHeight(),
							'min-height': $(window).height() - this.$siteHeader.outerHeight()
						});
						$('.fix-me-with-height').css({
							'min-height': $(window).height() - this.$siteHeader.outerHeight()
						});

					} else {

						$('.fix-me-with-margin').css('marginTop', '0');
						$('.fix-me-with-height, .fix-me-with-height-hard').attr('style', '');

					}

				}

				if ( $('.mount-product').length > 0 ) {

					$('.mount-product').each((function(key, elm){

						if ( window.CuberFixGalleryItem ) {
							$(elm).find('.gallery-item').css('height', ( $(window).height() - this.$siteHeader.outerHeight() ) * 0.8 );
						}

						$(elm).find('.product--section').removeClass('sticky-because');
						if ( $(elm).find('.site-box.box__product-gallery').css('content') != '"fix-me-also"' && $(elm).find('.site-box.box__product-gallery').height() < $(elm).find('.site-box.box__product-content').height() ) {
							$(elm).find('.product--section').addClass('sticky-because');
						}

					}).bind(this));

					/*if ( $('.site-box.box__product-gallery').css('content') == '"fix-me-also"' ) {
						$('.site-box.box__product-gallery').css('height', $(window).height() - this.$siteHeader.outerHeight());
					}*/

				}

				$('.site-header.desktop-view--classic .submenu').css('top', $('.site-header').outerHeight());

				if ( $('#site-menu-handle').css('opacity') == '1' ) {
					$('.site-nav.style--sidebar a, #site-menu-handle').attr('tabIndex', 0);
				} else {
					$('.site-nav.style--sidebar a, #site-menu-handle').attr('tabIndex', -1);
				}

			},

			_animateEverything: function(firstAnimation) {

				var i = 0;

				this.$siteBoxes.each(function(){

					var vp = 0;

					/*if ( ! firstAnimation ) {

						if ( ( $(this).height() - 100 ) > $(window).height() / 2 ) {
							vp = 0;
						} else {
							vp = 0;
						}
					}*/

					if ( ! $(this).hasClass('active') && $(window).scrollTop() + $(window).height() > $(this).offset().top + vp ) {

						i++;

						setTimeout((function(){
							$(this).addClass('active');
						}).bind(this), ( 100 * i ) );

					}

					if (this.$siteFooter && !this.$siteFooter.hasClass('active') && $(window).scrollTop() + $(window).height() > this.$siteFooter.offset().top + 150 ) {
						this.$siteFooter.addClass('active');
						this.$siteFooter.find('.site-box').addClass('active');
					}

				});
			},

			mount: function() {

    		$('.rte').fitVids();

			this.$siteFooter = $('.site-footer');
    		this.$siteBoxes = $('.site-box:not(.footer-box)');

    		if ( ! $('body').hasClass('ie9') ) {

					this._animateEverything(true);
	    		$(window).on('scroll.fade-animation', (function(e){
	 					this._animateEverything(false);
	    		}).bind(this));

	    	}

    		$('html.no-touchevents a[href]').each(function(){

	    		$(this).on('click', function(e){

	    			if ( ( e.ctrlKey || e.metaKey ) || $(this).attr('target') == '_blank' || $(this).hasClass('video-lightbox') || $(this).hasClass('lightbox') || $(this).hasClass('block-fade') || $(this).attr('href') == '' || $(this).attr('href').indexOf('#') >= 0 ) {
	    				//
	    			} else {

	    				$(this).off('click');

		    			$('body').fadeOut(200);
		    			setTimeout((function(){
		    				document.location.href = $(this).attr('href');
		    			}).bind(this), 200);
		    			e.preventDefault();
	    			}

		    	});

	    	});

				//

				this.$body = $('body');
				this.$siteHeader = $('#site-header');

				$(window).on('resize', window.debounce((function(){
					this._resizeEverything();
				}).bind(this), 300));
				this._resizeEverything();

				setTimeout((function(){
					this._resizeEverything();
				}).bind(this), 1000);

				if ( $('.logo-img').length > 0 && ! $('.logo-img img')[0].naturalWidth > 0 ) {
					$('.logo-img img').on('load', function(){
						window.CUBER.Main._resizeEverything();
					})
				}

				this.$searchForm = $('.search-bar:not(.no-ajax)');
				this.$searchResults = $('#search-results');
				this.$searchPreloader = $('#site-search .preloader');

				this.$searchForm.find('input[type="search"]').on('keyup', window.debounce((function(){
					this._ajaxSearchForm();
				}).bind(this), 300));

				this.$searchForm.submit((function(e){
					e.preventDefault();
					this._ajaxSearchForm();
				}).bind(this));

				// tabs & toggles

				if ( $('.krown-tabs').data('design') == 'toggles' ) {

		      $('.krown-tabs').each(function(){

		        var $titles = $(this).children('.titles').children('h5'),
		            $contents = $(this).find('.contents').children('div'),
		            i = 0;

		        $titles.each(function(){

		          $contents.eq(i++).insertAfter($(this));

		          $(this).on('click', function(){

		            var $toggle = $(this).next('.tab');

		            if ( ! $(this).hasClass('opened') ) {
		              $(this).addClass('opened');
		              $toggle.stop().slideDown(200);
		            } else {
		              $(this).removeClass('opened');
		              $toggle.stop().slideUp(200);
		            }

		          });

		        });

		        $(this).find('.contents').remove();

		      });

		    } else {

		      $('.krown-tabs').each(function(){

		        var $titles = $(this).children('.titles').children('h5'),
		        $contents = $(this).children('.contents').children('div'),
		        $openedT = $titles.eq(0),
		        $openedC = $contents.eq(0);

		        $openedT.addClass('opened');
		        $openedC.stop().slideDown(0);

		        $titles.find('a').prop('href', '#').off('click');;

		        $titles.click(function(e){

		          $openedT.removeClass('opened');
		          $openedT = $(this);
		          $openedT.addClass('opened');

		          $openedC.stop().slideUp(200);
		          $openedC = $contents.eq($(this).index());
		          $openedC.stop().delay(200).slideDown(200);

		          e.preventDefault();

		        });

		      });

		    }

		    if ( $('.site-footer .info').length > 0 ) {
		    	if ( $('.site-footer .info').html().split('').length > 18 ) {
		    		$('.site-footer .info').addClass('smaller');
		    	}
		    }

			},

			_ajaxSearchForm: function() {

				this.$searchPreloader.css('opacity', 1);

	  		$.ajax({

	  			type: this.$searchForm.prop('method'),
	  			url: this.$searchForm.prop('action'),
	  			data: this.$searchForm.serialize(),
	  			success: (function(data){

	  				this.$searchResults.html($(data).find('.search-results.with-results'));
						this.$searchPreloader.css('opacity', 0);

						$('#site-search').off('scroll.search-pagination');

						if ( $('.search-results').find('.next-page').length > 0 ) {
							this.$searchPagination = $('.search-results').find('.next-page');
							$('#site-search').on('scroll.search-pagination', this._ajaxSearchPagination.bind(this));
						}

	  			}).bind(this)

	  		});

			},

			_ajaxSearchPagination: function() {

				if ( $('#site-search').scrollTop() + $(window).height() >= this.$searchPagination.offset().top - 250 ) {

					this.$searchPreloader.css({'opacity': 1, 'top': 'auto', 'bottom': '-60px'});
					$('#site-search').off('scroll.search-pagination');

					$.ajax({

						url: this.$searchPagination.attr('href'),
						success: (function(data){

							this.$searchResults.find('.next-page').remove();
							this.$searchResults.append($(data).find('.search-item'));

							if ( $(data).find('.search-results .next-page').length > 0 ) {
								this.$searchResults.append($(data).find('.search-results .next-page'));
								this.$searchPagination = $('.search-results').find('.next-page');
								$('#site-search').on('scroll.search-pagination', this._ajaxSearchPagination.bind(this));
							}

							this.$searchPreloader.css({'opacity': 0, 'top': '20px', 'bottom': 'auto'});

						}).bind(this)

					})

				}

			},

			unmount: function() {
				$(window).off('scroll.scroll-movers');
			}

		},

		Contact: {

			mount: function($elm) {

				if ( $elm.find('.contact-map-holder').length > 0 ) {

					if ( $elm.find('.contact-map-object').data('address') != '' ) {

						if ( typeof google !== 'undefined' ) {
							this._createMap($elm.attr('id'), $elm.find('.contact-map-object'), $elm.find('.contact-map-address-holder'));
						} else {

							if ( window.loadingGoogleMapsScript ) {
								$elm.ti = setInterval((function($elm){
									if ( typeof google !== 'undefined' ) {
										clearInterval($elm.ti);
										this._createMap($elm.attr('id'), $elm.find('.contact-map-object'), $elm.find('.contact-map-address-holder'));
									}
								}).bind(this, $elm), 100);

							} else {

								window.loadingGoogleMapsScript = true;
								$.getScript('https://maps.googleapis.com/maps/api/js?v=3&key='+ $elm.find('.contact-map-holder').data('key')).done((function(){
									this._createMap($elm.attr('id'), $elm.find('.contact-map-object'), $elm.find('.contact-map-address-holder'));
								}).bind(this));

							}
						}

					}

				}

			},

			_createMap: function(id, $mapInsert, $mapAddress) {

				$mapInsert.attr('id', 'contact-map-' + id);

				var coordsKey = 'map-coords-' + $mapInsert.attr('id'),
						coordsStorage = localStorage.getItem(coordsKey) != null ? JSON.parse(localStorage.getItem(coordsKey)) : null,
						mapLat = 0,
						mapLong = 0;

				if ( coordsStorage != null && coordsStorage['address'] == $mapInsert.data('address') ) {
					mapLat = coordsStorage['lat'];
					mapLong = coordsStorage['long'];
				}

	     	var geocoder, map, address;

    		geocoder = new google.maps.Geocoder();
    		address = $mapInsert.data('address');

		    var mapOptions = {
		      zoom: $mapInsert.data('zoom'),
		      center: new google.maps.LatLng(mapLat, mapLong),
		      streetViewControl: false,
		      scrollwheel: true,
		      panControl: false,
		      mapTypeControl: false,
		      overviewMapControl: false,
		      zoomControl: false,
		      draggable: true,
		      styles: $mapInsert.data('style') == 'light' ? window.lightMapStyle : window.darkMapStyle
		    };

		    map = new google.maps.Map(document.getElementById($mapInsert.attr('id')), mapOptions);

		    if ( mapLat != 0 || mapLong != 0 ) {

			    var markerOptions = {
	          position: new google.maps.LatLng(mapLat, mapLong),
	          map: map,
	          title: address
			    }

			    if( $mapInsert.data('marker') != 'none' ) {
			    	markerOptions['icon'] = {
		          url: $mapInsert.data('marker'),
		          scaledSize: new google.maps.Size(60, 60)
			      }
			    }

			    $mapAddress.find('a').attr('href', 'http://www.google.com/maps/place/' + mapLat + ',' + mapLong);
			    var contentString = $mapAddress.html();
	        var infowindow = new google.maps.InfoWindow({
	          content: contentString
	        });

          var marker = new google.maps.Marker(markerOptions);
	        marker.addListener('click', function() {
	          infowindow.open(map, marker);
	          if ( $(window).width() < 480 ) {
	          	$('.template-page-contact .box__heading .title').css('marginTop', 50);
	          } else if ( $(window).width() < 768 ) {
	          	$('.template-page-contact .box__heading .title').css('marginTop', 100);
	          }
	        });

          if ( $(window).width() > 768 ) {
						map.panBy(-150, 150);
          } else {
						map.panBy(-75, 75);
          }

		    } else {

			    if ( geocoder ) {

			    	geocoder.geocode( { 'address': address }, function(results, status){

			    		if (status == google.maps.GeocoderStatus.OK) {
			          if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {

			          	map.setCenter(results[0].geometry.location);

							    var markerOptions = {
					          position: results[0].geometry.location,
					          map: map,
					          title: address
							    }

							    if( $mapInsert.data('marker') != 'none' ) {
							    	markerOptions['icon'] = {
						          url: $mapInsert.data('marker'),
						          scaledSize: new google.maps.Size(60, 60)
							      }
							    }

							    $mapAddress.find('a').attr('href', 'http://www.google.com/maps/place/' + results[0].geometry.location.lat() + ',' + results[0].geometry.location.lng());
							    var contentString = $mapAddress.html();
					        var infowindow = new google.maps.InfoWindow({
					          content: contentString
					        });

			            var marker = new google.maps.Marker(markerOptions);
					        marker.addListener('click', function() {
					          infowindow.open(map, marker);
					        });

				          if ( $(window).width() > 768 ) {
										map.panBy(-150, 150);
				          } else {
										map.panBy(-75, 75);
				          }

			  					localStorage.setItem(coordsKey, JSON.stringify({
			  						'address': $mapInsert.data('address'),
			  						'lat': results[0].geometry.location.lat(),
			  						'long': results[0].geometry.location.lng()
			  					}));

			          } else {
			            alert("No results found for the given address");
			          }
			        } else {
			          console.log("Geocode was not successful for the following reason: " + status);
			        }

			    	});

		   		}

		   	}

			},

			unmount: function() {

			}

		},

		// SCROLL

		Scroll: {

			$body: null,
			$footer: null,

			mount: function() {

				if ( ! $('html').hasClass('csspositionsticky') ) {

					this.$body = $('body');
					this.$footer = $('#shopify-section-footer');

					// grid

					var scrollFixArray = [];

					if ( $(window).width() > 768 ) {

						$('.site-box-container.container--fullscreen.box--can-stick').each(function(){

							var $boxChildren = $(this).children('.site-box');

							if ( $boxChildren.length == 2 ) {

								if ( $(this).children('.site-box[data-order="0"]').outerHeight(true) != $(this).children('.site-box[data-order="1"]').outerHeight(true) ) {

									var $bigChild = null,
											$smallChild = null;

									if ( $(this).children('.site-box[data-order="0"]').outerHeight(true) > $(this).children('.site-box[data-order="1"]').outerHeight(true) ) {
										$bigChild = $(this).children('.site-box[data-order="0"]');
										$smallChild = $(this).children('.site-box[data-order="1"]');
									} else if ( $(this).children('.site-box[data-order="1"]').outerHeight(true) > $(this).children('.site-box[data-order="0"]').outerHeight(true) ) {
										$bigChild = $(this).children('.site-box[data-order="1"]');
										$smallChild = $(this).children('.site-box[data-order="0"]');
									}

									scrollFixArray.push({
										'parent': $(this),
										'big-child': $bigChild,
										'small-child': $smallChild
									});

								}

							} else if ( $boxChildren.length == 1 ) {

								if ( $(this).children('.site-box[data-order="0"]').outerHeight(true) > $(window).height() ) {

									scrollFixArray.push({
										'parent': $(this),
										'big-child': $(this).children('.site-box[data-order="0"]'),
										'small-child': null
									});

								}

							}

						});

					}

					scrollFixArray.forEach(function(obj){

						obj['parent'].removeClass('fixing-scroll-now');
							obj['big-child'].css({'position': 'relative', 'top': '0', 'bottom': 'auto', 'marginLeft': '0'});

						if ( obj['small-child'] != null ) {
							obj['small-child'].css({'position': 'relative', 'top': '0', 'bottom': 'auto', 'marginLeft': '0'});
							obj['small-child'].removeClass('ok-scroll');
						}


					});

					$(window).off('scroll.scroll-fix');

					scrollFixArray.forEach(function(obj) {

						if ( $(window).scrollTop() + $(window).height() >= obj['parent'].offset().top + obj['parent'].outerHeight() ) {

							if ( obj['small-child'] != null  ) {
								obj['small-child'].css({'position': 'absolute', 'bottom': 0, 'top': 'auto' });
								if ( obj['small-child'].attr('data-order') == '1' ) {
									obj['small-child'].css('marginLeft', '50%');
								}
							}

							if ( obj['big-child'].attr('data-order') == '1' ) {
								obj['big-child'].css('marginLeft', '50%');
							}

						}

					})

					$(window).on('scroll.scroll-fix', (function(){

						if ( $(window).scrollTop() >= 0 ) {

							scrollFixArray.forEach(function(obj){

								if ( $(window).scrollTop() >= obj['parent'].offset().top && $(window).scrollTop() + $(window).height() < obj['parent'].offset().top + obj['parent'].outerHeight() && ! obj['parent'].hasClass('fixing-scroll-now') ) {

									obj['parent'].addClass('fixing-scroll-now');

									if ( obj['small-child'] != null ) {

										obj['small-child'].css({'position': 'fixed', 'top': 0, 'bottom': 'auto'});

										if ( obj['small-child'].attr('data-order') == '1' ) {
											obj['small-child'].css('marginLeft', '50%');
										}

										if ( obj['small-child'].height() > $(window).height() ) {
											obj['small-child'].addClass('ok-scroll');
										}

									}

									if ( obj['big-child'].attr('data-order') == '1' ) {
										obj['big-child'].css('marginLeft', '50%');
									}

								}

								if ( $(window).scrollTop() + $(window).height() >= obj['parent'].offset().top + obj['parent'].outerHeight() && obj['parent'].hasClass('fixing-scroll-now') ) {

									obj['parent'].removeClass('fixing-scroll-now');

									if ( obj['small-child'] != null ) {
										obj['small-child'].removeClass('ok-scroll');
										obj['small-child'].css({'position': 'absolute', 'bottom': 0, 'top': 'auto' });
									}

								}

								if ( $(window).scrollTop() < obj['parent'].offset().top && obj['parent'].hasClass('fixing-scroll-now') ) {

									obj['parent'].removeClass('fixing-scroll-now');
									obj['big-child'].css('marginLeft', '0');

									if ( obj['small-child'] != null ) {
										obj['small-child'].css({'position': 'relative', 'top': '0', 'bottom': 'auto', 'marginLeft': '0'});
									}


								}
								if ( obj['small-child'] != null && obj['small-child'].height() > $(window).height() && obj['small-child'].hasClass('ok-scroll') ) {

									var x = obj['big-child'].height() - $(window).height(),
											y = $(window).height() - obj['small-child'].height(),
											z = $(window).scrollTop();

									//obj['small-child'].css('top', Math.ceil(z * y / x));

								}


							});

						}

					}).bind(this)).trigger('scroll.scroll-fix');

					$(window).off('resize.scroll-fix');
					$(window).on('resize.scroll-fix', window.debounce((function(){
						window.CUBER.Scroll.mount();
					}).bind(this), 250));

				}

			},

			unmount: function() {

				$(window).off('resize.scroll-fix');
				$(window).off('scroll.scroll-fix');

			}

		},

		// IMAGES

		Images: {

			boxImages: [],

			mount: function() {

				this.boxImages = [];

				if ( $('.box--product-image').length > 0 ) {
					$('.box--product-image:not(.on)').each((function(key, elm){

						$(elm).addClass('on');
						this.boxImages.push({
							'$elm': $(elm),
							'img': $(elm).children('img')[0],
							'srcset': $(elm).children('img').data('srcset')
						});

					}).bind(this));
				}

				$(window).on('resize.box-images', (function(){

					this.boxImages.forEach(function(entry){

	        	var desiredDensity = window.devicePixelRatio <= 2 ? window.devicePixelRatio : 2,
	        			desiredSize = entry['$elm'].width() * desiredDensity;

	        	if ( entry['img'].naturalWidth > 0 ) {

	        		if ( entry['$elm'].width() / entry['$elm'].height() < entry['img'].naturalWidth / entry['img'].naturalHeight ) {
	        			var desiredHeight = Math.ceil(( entry['$elm'].height() * desiredDensity ));
	        			desiredSize = desiredHeight * entry['img'].naturalWidth / entry['img'].naturalHeight;
	        		}

	        	}

						if ( desiredSize <= 480 ) {
							entry['$elm'].css('backgroundImage', 'url(' + entry['srcset'].small + ')');
						} else if ( desiredSize <= 960 ) {
							entry['$elm'].css('backgroundImage', 'url(' + entry['srcset'].medium + ')');
						} else if ( desiredSize <= 1440 ) {
							entry['$elm'].css('backgroundImage', 'url(' + entry['srcset'].large + ')');
						} else if ( desiredSize > 1440 ) {
							entry['$elm'].css('backgroundImage', 'url(' + entry['srcset'].huge + ')');
						}

					});

				}).bind(this)).trigger('resize.box-images');

			},

			unmount: function() {
				$(window).off('resize.box-images');
			}

		},

		Video: {

			mount: function() {

				if ( $('.video-lightbox').length > 0 ) {
					$('.video-lightbox').magnificPopup({
						type: 'iframe',
						iframe: {
							patterns: {
								youtube: {
									index: 'youtube.com',
									id: 'v=',
									src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1'
								}
							}
						}
					});
				}

			},

			unmount: function() {
			}

		},

		Popup: {

			$popup: null,

			mount: function() {

				this.$popup = $('#shopify-section-popup');

				var show = this.$popup.find('.popup-content').data('show'),
						freq = this.$popup.find('.popup-content').data('freq'),
						enable = this.$popup.find('.popup-content').data('enable');

				if ( show > 0 && enable ) {
					setTimeout((function(){
						this._trigger(show, freq);
					}).bind(this), parseInt(show*1000));
				}

				this.$popup.find('.site-close-handle').on('click', (function(e){
					this._hide();
				}).bind(this));

				this.$popup.find('.popup-background').on('click', (function(e){
					this._hide();
				}).bind(this));

			},

			_show: function() {
				this.$popup.addClass('active');
			},

			_hide: function() {
				this.$popup.removeClass('active');
			},

			_trigger: function(show, freq) {

				var popupKey = 'popup-' + document.location.hostname,
						popupStorage = localStorage.getItem(popupKey) != null ? JSON.parse(localStorage.getItem(popupKey)) : null;

				if ( popupStorage != null ) {

					if ( popupStorage['show'] != show || popupStorage['freq'] != freq ) {

						this._refreshStorage(popupKey, show, freq);;

						// user saw the ad but settings are different - show it!
						this._show();

					} else {

						// user saw the ad so we need to check if he should see it again

						if ( freq == 'every' ) {

							if ( sessionStorage[popupKey] == null || sessionStorage[popupKey] != 'shown' ) {
								this._show();
								this._refreshStorage(popupKey, show, freq);;
							}

						} else {

							var shownAt = popupStorage['shown'],
									nowAt = new Date().getTime(),
									inBetween = Math.round((nowAt - shownAt) / 1000);

							if ( freq == 'day' && inBetween > 129600 ) {
								this._show();
								this._refreshStorage(popupKey, show, freq);;
							} else if ( freq == 'week' && inBetween > 907200 ) {
								this._show();
								this._refreshStorage(popupKey, show, freq);;
							}

						}

					}

				} else {

					this._refreshStorage(popupKey, show, freq);

					// user never saw the ad - show it!

					this._show();

				}

			},

			_refreshStorage: function(popupKey, show, freq) {

				localStorage.setItem(popupKey, JSON.stringify({
					'show': show,
					'freq': freq,
					'shown': new Date().getTime()
				}));

				sessionStorage[popupKey] = 'shown';

			},

			unmount: function() {
			}

		},

		// SOCIAL

		Social: {

			$container: null,
			nameTwitter: '',
			nameInstagram: '',

			mount: function( $elm ) {

				this.$container = $elm.children('.site-box-container');
				this.nameTwitter = this.$container.data('twitter');
				this.nameInstagram = this.$container.data('instagram');

				var no = this.$container.data('posts'),
						noT = 0,
						noI = 0,
						socialArr = [];

				if ( this.nameTwitter != '' && this.nameInstagram != '' ) {
					noT = Math.ceil(no/2);
					noI = Math.floor(no/2);
				} else if ( this.nameTwitter != '' ) {
					noT = no;
				} else if ( this.nameInstagram != '' ) {
					noI = no;
				}

				if ( noI > 0 ) {

					var feed = new Instafeed({

						get: 'user',
						userId: this.nameInstagram.split('.')[0],
						accessToken: this.nameInstagram,
						limit: noI,
						resolution: 'standard_resolution',
						mock: true,
						sortBy: 'random',
						success: (function(obj) {

							obj.data.forEach(function(entry){

								socialArr.push({
									'type': 'instagram',
									'thumb': entry.images.standard_resolution.url,
									'link': entry.link,
									'caption': typeof entry.caption === 'object' && entry.caption !== null ? entry.caption.text : '',
									'likes': entry.likes.count,
									'time': new Date(entry.created_time*1000).toLocaleDateString('en-US'),
									'timestamp': parseInt(entry.created_time)
								});
							});

							this._pushFeed('instagram', socialArr);

						}).bind(this)

					});

					feed.run();

				} else {
					this._pushFeed('instagram', socialArr);
				}

				if ( noT > 0 ) {

					twitterFetcher.fetch({

					  'profile': {'screenName': this.nameTwitter},
					  'dataOnly': true,
					  'maxTweets': noT,
					  'dateFunction': function(date){
					  	return parse(date);
					  },
					  'customCallback': (function(obj){

					  	obj.forEach(function(entry){
					  		socialArr.push({
					  			'type': 'twitter',
					  			'text': entry.tweet,
					  			'timestamp': Date.parse(entry.timestamp)/1000
					  		})
					  	});

							this._pushFeed('twitter', socialArr);

					  }).bind(this)

					});

				} else {
					this._pushFeed('twitter', socialArr);
				}

			},

			_pushFeed: function(type, feed) {

				if ( type == 'twitter' ) {
					this.checkTwitter = true;
				} else if ( type == 'instagram' ) {
					this.checkInstagram = true;
				}

				if ( this.checkTwitter && this.checkInstagram ) {

					feed.sort(function(a, b){
						return a.timestamp - b.timestamp;
					}).reverse();

					feed.forEach((function(entry, key){

						var feedContent = '';

						if ( entry.type == 'twitter' ) {

							feedContent += '<div class="site-box-content">';
								feedContent += '<span class="icon" aria-hidden="true">' + $.themeAssets.iconTwitter + '</span>';
								feedContent += '<p>' + entry.text + '</p>';
								feedContent += '<a href="https://twitter.com/' + this.nameTwitter + '" target="_blank">@' + this.nameTwitter + '</a>';
							feedContent += '</div>';

						} else if ( entry.type == 'instagram' ) {

							feedContent += '<div class="site-box-content" style="background-image:url(' + entry.thumb + ')">';
								feedContent += '<a href="' + entry.link + '" target="_blank">';
									feedContent += '<span class="icon child" aria-hidden="true">' + $.themeAssets.iconInstagram + '</span>';
									feedContent += '<p class="caption child">' + entry.caption + '</p>';
									feedContent += '<div class="meta child">';
										feedContent += '<span class="likes">' + $.themeAssets.iconHeart + entry.likes + '</span>';
										feedContent += '<span class="time">' + entry.time + '</span>';
									feedContent += '</div>';
								feedContent += '</a>';
							feedContent += '</div>';

						}

						this.$container.find('.site-box[data-order="' + (key+1) + '"]')
							.removeClass('box__twitter').removeClass('box__instagram')
							.addClass('box__' + entry.type)
							.html(feedContent);

					}).bind(this));

				}

			},

			unmount: function() {
				//
			}

		},

		SplitSlider: {

			_mountFlickity: function() {

				$('.responsive-flickity').flickity({
					cellSelector: '.slideshow-item',
					wrapAround: true,
					prevNextButtons: false,
					pageDots: false,
					watchCSS: true,
					resize: true
				});

				var $slider = $('.box__slideshow-split'),
						flkty = $('.responsive-flickity').data('flickity'),
						currentI = 0,
						totalI = 100 / ( $slider.find('.slideshow-item').length - 1 ),
						$currentSlide = null,
						$currentSlideBlack = null;

				if ( $slider.find('.slider-meta').length <= 0 ) {

					$slider.find('.slider-meta').remove();

					$slider.append('<div class="slider-meta hide lap--show"><div class="slider-index"><span class="current">1</span> / <span class="total">' + sliderT + '</span></div><div class="slider-nav"><span class="go-prev">' + $.themeAssets.arrowRight + '</span><span class="go-next">' + $.themeAssets.arrowRight + '</span></div>' );

					$slider.find('.go-prev').on('click', (function(){
						flkty.previous();
					}).bind(this));

					$slider.find('.go-next').on('click', (function(){
						flkty.next();
					}).bind(this));

					$('.responsive-flickity').on('select.flickity', function(){
						$slider.find('.slider-index .current').html(flkty.selectedIndex + 1);
					});

					setTimeout(function(){
						$slider.find('.slider-meta').addClass('active');
					}, 1000);

				}

			},

			mount: function( flick ) {

				var $slider = $('.box__slideshow-split'),
						$slides = $slider.find('.slideshow-item'),
						$slidesMedia = $slider.find('.site-box-background-container').children('div'),
						slidesBlackArray = [];

						currentScroll = $(window).scrollTop(),

						sliderI = Math.min( Math.ceil(currentScroll / $(window).height()), $slides.length-1 );
						sliderJ = sliderI-1,
						sliderT = $slides.length;
				// mobile slider

				if ( flick ) {
					this._mountFlickity();
				}

				if ( $('.responsive-flickity').hasClass('flickity-enabled') ) {
					$slider.height($(window).height() - $('#site-header').outerHeight());
					$slider.addClass('remove-min-height');
				} else {
					$slider.css('height', 'auto');
					$slider.removeClass('remove-min-height');
				}

				// split

				$slidesMedia.each(function(key){

					if ( key > 0 ) {
						if ( key < sliderI ) {
							$(this).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + $(window).height() + 'px 0)');
						} else if ( key == sliderI ) {
							$(this).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + ( Math.ceil($(window).scrollTop() - $(window).height() * sliderJ ) ) + 'px 0)');
						} else {
							$(this).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px 0 0)');
						}

					} else if ( key == 0 & flick ) {
                      $(this).css({
							'clip': 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px 0 0)',
							'opacity': 0
						});

						$(this).addClass('clip-transition');
						setTimeout((function(){
							$(this).css({
								'clip': 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + $(window).height() + 'px 0)',
								'opacity': 1
							});
						}).bind(this), 10);

						setTimeout((function(){
							$(this).removeClass('clip-transition');
						}).bind(this), 650);

					}

					$(this).addClass('active');

					if ( $(this).find('.site-box-black-overlay').length <= 0 ) {
						$(this).append('<span class="site-box-black-overlay" />');
					}
					slidesBlackArray.push($(this).find('.site-box-black-overlay'));

				});

				$(window).on('scroll.split-slider', function(e){

					if ( currentScroll < $(window).scrollTop() ) {

						// next
						if ( $slides.eq(sliderI+1).length > 0 && $(window).scrollTop() + $(window).height() >= $slides.eq(sliderI+1).offset().top) {

							if ( sliderI != 0 ) {
								// finish scroll
								$slidesMedia.eq(sliderI).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + $(window).height() + 'px 0)');
								if ( slidesBlackArray[sliderJ] ) {
									slidesBlackArray[sliderJ].css('opacity', 0.5 );
								}
							}

							sliderJ = sliderI;
							sliderI++;
							down = true;

						} else if ( $(window).scrollTop() + $(window).height() >= $slider.height() && ! $slider.hasClass('back-to-normal') ) {
							$slider.addClass('back-to-normal');
								$slidesMedia.eq(sliderI).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + $(window).height() + 'px 0)');
						}

					} else {

						// prev
						if ( $slides.eq(sliderI).length > 0 && $slides.eq(sliderI-1).length > 0 && $(window).scrollTop() + $(window).height() < $slides.eq(sliderI).offset().top ) {

							// finish scroll

							var stupid = $slidesMedia.eq(sliderI).hasClass('obs') ? 1 : 0;

							$slidesMedia.eq(sliderI).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + stupid + 'px 0)');
							if ( slidesBlackArray[sliderJ] ) {
								slidesBlackArray[sliderJ].css('opacity', 0 );
							}

							sliderI--;
							sliderJ = sliderI-1;
							down = false;

						} else if ( $(window).scrollTop() + $(window).height() <= $slider.height() && $slider.hasClass('back-to-normal') ) {
							$slider.removeClass('back-to-normal');
						}

					}

					if ( ! $slider.hasClass('back-to-normal') ) {

						var scrollValue = Math.ceil($(window).scrollTop() - $(window).height() * sliderJ );

						var stupid = $slidesMedia.eq(sliderI).hasClass('obs') ? 1 : 0;

						$slidesMedia.eq(sliderI).css('clip', 'rect(0 ' + Math.ceil($(window).width() / 2) + 'px ' + Math.max(stupid, scrollValue) + 'px 0)');

						if ( slidesBlackArray[sliderJ] ) {
							slidesBlackArray[sliderJ].css('opacity', ( Math.ceil(scrollValue * 50 / $(window).height()) ) / 100 );
						}

						var scrollFactor = Math.round($(window).height() / 6);

						$slides.eq(sliderJ).find('.caption').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*1 ) / $(window).height() ) ) + 'px)');
						$slides.eq(sliderJ).find('.title').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.75 ) / $(window).height() ) ) + 'px)');
						$slides.eq(sliderJ).find('.subtitle').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.5 ) / $(window).height() ) ) + 'px)');
						$slides.eq(sliderJ).find('.button').css('transform', 'translateY(' + ( 0 - Math.ceil(scrollValue * ( scrollFactor*0.25 ) / $(window).height() ) ) + 'px)');

						$slides.eq(sliderI).find('.caption').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 1) / $(window).height()) - ( scrollFactor * 1) ) + 'px)');
						$slides.eq(sliderI).find('.title').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.75) / $(window).height()) - ( scrollFactor * 0.75) ) + 'px)');
						$slides.eq(sliderI).find('.subtitle').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.5) / $(window).height()) - ( scrollFactor * 0.5) ) + 'px)');
						$slides.eq(sliderI).find('.button').css('transform', 'translateY(' + ( Math.ceil(scrollValue * ( scrollFactor * 0.25) / $(window).height()) - ( scrollFactor * 0.25) ) + 'px)');

					}

					currentScroll = $(window).scrollTop();

				}).trigger('scroll.split-slider');

				$(window).on('resize.split-slider', window.debounce((function(){

					this.unmount();
					this.mount(false);

				}).bind(this), 250));

			},

			unmount: function() {
				$(window).off('scroll.split-slider');
			}

		}

	}

	$(document).on('ready', function(){

		window.CUBER.Nav.mount();
		window.CUBER.Main.mount();
 		window.CUBER.Scroll.mount();

		if ( $('.mount-social').length > 0 ) {
			$('.mount-social').each(function(){
				window.CUBER.Social.mount($(this));
			})
		}

		if ( $('.box__slideshow-split').length > 0 ) {
			window.CUBER.SplitSlider.mount(true);
		}

		if ( $('.mount-product').length > 0 ) {
			$('.mount-product').each(function(){
				window.CUBER.Product.mount($(this));
			});
		}
		if ( $('body').hasClass('template-collection') ) {
			window.CUBER.Collection.mount();
		}
		if ( $('body').hasClass('template-page-contact') || ( $('body').hasClass('template-index') ) && $('.mount-map').length > 0 ) {
			$('.mount-map').each(function(){
				window.CUBER.Contact.mount($(this));
			});
		}

		//window.CUBER.Images.mount();
		window.CUBER.Video.mount();

		window.CUBER.Popup.mount();

		// Section events

		// select

		$(document).on('shopify:section:select', function(e){

	 		var $section = $(e.target);

	 		if ( $section.hasClass('mount-header') ) {

	 			if ( $section.find('#site-header').hasClass('style--sidebar' ) || $section.find('#site-header').hasClass('style--fullscreen' ) ) {
	 				if ( ! $section.find('#site-nav').hasClass('active') ) {
	 					$('#site-menu-handle a').trigger('click');
	 				}
	 			}

	 		}

	 		if ( $('#site-header').hasClass('desktop-view--minimal') && $('#fix-me-header').css('display') == 'none' ) {
	 			setTimeout(function(){
	 				$('html, body').stop().animate({'scrollTop': $section.offset().top}, 0);
	 			}, 400);
	 		}

	 		if ( $section.hasClass('mount-popup') ) {
	 			window.CUBER.Popup._show();
	 		}

	 	});

		// deselect

		$(document).on('shopify:section:deselect', function(e){

	 		var $section = $(e.target);

	 		if ( $section.hasClass('mount-header') ) {

	 			if ( $section.find('#site-header').hasClass('style--sidebar' ) || $section.find('#site-header').hasClass('style--fullscreen' ) ) {
	 				if ( $section.find('#site-nav').hasClass('active') ) {
	 					$('#site-menu-handle a').trigger('click');
	 				}
	 			}

	 		}

	 		if ( $section.hasClass('mount-popup') ) {
	 			window.CUBER.Popup._hide();
	 		}


		});

		// load

		$(document).on('shopify:section:load', function(e){

	 		var $section = $(e.target);

	 		if ( $section.hasClass('mount-header') ) {
	 			window.CUBER.Nav.mount();
	 		}
	 		if ( $section.hasClass('mount-images') ) {
	 			//window.CUBER.Images.mount();
	 		}
	 		if ( $section.hasClass('mount-video') ) {
				window.CUBER.Video.mount();
	 		}
	 		if ( $section.hasClass('mount-social') ) {
				window.CUBER.Social.mount($section);
	 		}
	 		if ( $section.hasClass('mount-slideshow') && $section.find('.box__slideshow-split').length > 0 ) {
	 			window.CUBER.SplitSlider.mount(true);
	 			$(window).scrollTop(0);
	 		}
	 		if ( $section.hasClass('mount-product') ) {
				window.CUBER.Product.mount($section);
	 		}
	 		if ( $section.hasClass('mount-map') ) {
				window.CUBER.Contact.mount($section);
	 		}

	 		if ( $section.hasClass('mount-popup') ) {
	 			window.CUBER.Popup.mount();
	 		}

	 		window.CUBER.Main.mount();
	 		window.CUBER.Scroll.mount();

		});

		// unload

		$(document).on('shopify:section:unload', function(e){

	 		var $section = $(e.target);

	 		if ( $section.hasClass('mount-header') ) {
	 			window.CUBER.Nav.unmount();
	 		}
	 		if ( $section.hasClass('mount-images') ) {
	 			window.CUBER.Images.unmount();
	 		}
	 		if ( $section.hasClass('mount-video') ) {
	 			window.CUBER.Video.unmount();
	 		}
	 		if ( $section.hasClass('mount-social') ) {
				window.CUBER.Social.unmount();
	 		}
	 		if ( $section.hasClass('mount-slideshow') && $section.find('.box__slideshow-split').length > 0 ) {
	 			window.CUBER.SplitSlider.unmount();
	 		}
	 		if ( $section.hasClass('mount-product') ) {
				window.CUBER.Product.unmount($section);
	 		}
	 		if ( $section.hasClass('mount-map') ) {
				window.CUBER.Contact.unmount();
	 		}

	 		window.CUBER.Main.unmount();
	 		window.CUBER.Scroll.unmount();

		});

		// blocks

		$(document).on('shopify:block:select', function(e){

			var $block = $(e.target);
			if ( $block.hasClass('slideshow-item') ) {
				if ( $('.responsive-flickity').hasClass('flickity-enabled') ) {
					$('.responsive-flickity').data('flickity').select($block.index())
				} else {
					$(window).scrollTop($block.offset().top);
				}
	 			$block.find('.caption, .title, .subtitle').css('transform', 'translateY(0)');
			}

		});

		// Various stuff that doesn't need remounting

		$(window).on('resize', function(){
			if ( $(window).width() < 1024 ) {

			}
		});

		$('.simple-grid select:not(.styled)').each(function(){
			$(this).styledSelect({
				coverClass: 'regular-select-cover',
				innerClass: 'regular-select-inner'
			}).addClass('styled');
			$(this).parent().append($.themeAssets.arrowDown);
		});

		if ( $('body').hasClass('template-customers-login') ) {

			if ( $('#RecoverPassword').length > 0 ) {

				$('#RecoverPassword').on('click', function(e){
					$('#CustomerLoginForm').hide();
					$('#RecoverPasswordForm').show();
					$('#LoginRecoverTitle').html($('#LoginRecoverTitle').data('password_recovery'));
					e.preventDefault();
				});

				$('#HideRecoverPasswordLink').on('click', function(e){
					$('#RecoverPasswordForm').hide();
					$('#CustomerLoginForm').show();
					$('#LoginRecoverTitle').html($('#LoginRecoverTitle').data('login'));
					e.preventDefault();
				});

				if (window.location.hash == '#recover') {
					$('#RecoverPassword').trigger('click');
				}

			}

		} else if ( $('body').hasClass('template-customers-addresses') ) {
			$('#section-addresses a').on('click', function(){
				window.CUBER.Scroll.mount();
			})
		}

		//

		if ( $('body').hasClass('template-blog') || $('body').hasClass('template-article') ) {

			window.CUBER.Main._mountScrollMovers({
				'parent': $('.scroll-movers-parent'),
				'items': $('.site-sharing')
			});

			window.CUBER.Main._mobileSharingInit();

		}


    // Start Custom

    function isInOrBelowViewport(element) {
      var elementTop = element.offset().top;
      var elementBottom = elementTop + element.outerHeight();
      var viewportTop = $(window).scrollTop();

      return elementBottom > viewportTop;
    }

    function toggleStickyBuy(element) {



      if (isInOrBelowViewport(element)) {
        stickyBuy.addClass('sticky-buy-hidden');
      } else {
        stickyBuy.removeClass('sticky-buy-hidden');
      }
    }

    var stickyBuy = $('.sticky-buy');
    if (stickyBuy.length) {
		setTimeout(function () {
          stickyBuy.addClass('sticky-buy-visible');
        }, 250);

      if ($('body').hasClass('template-index') || $('#banner-section').length) {
        toggleStickyBuy($('#banner-section').find('a.button'));
        $(window).scroll(function() {
          toggleStickyBuy($('#banner-section').find('a.button'));
        });
      }

      if ($('body').hasClass('template-page-app')) {
        toggleStickyBuy($('#site-footer').find('h4'));
        $(window).scroll(function() {
          toggleStickyBuy($('#site-footer').find('h4'));
        });
      }

      if ($('body').hasClass('template-product')) {
        toggleStickyBuy($('#main-form').find('button[name="add"]'));
        $(window).scroll(function() {
          toggleStickyBuy($('#main-form').find('button[name="add"]'));
        });

        stickyBuy.click(function(event) {
          event.preventDefault();
          var buyButton = $('.product--add-to-cart-form .shopify-product-form').find('button[name="add"]');
          if (!buyButton.find('.preloader').length) {
            buyButton.click();
          }
        });
      }
	  

    }

    // var rosaBollenInfo = $('.rosa-bollen-info');
    // if (rosaBollenInfo.length) {
    //   rosaBollenInfo.find('.rosa-bollen-info-info-icon').click(function() {
    //     $(this).next('.rosa-bollen-info-info-box').toggleClass('rosa-bollen-info-info-box-active');
    //   });
    // }

    // End Custom

	});

})(jQuery);

function response(data) {
	console.log(data);
}

window._getLuminance = function(hexy) {
  var rgb = this._toRgb(hexy);
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
}

window._toRgb = function(hexy) {
	var hex = hexy.replace('rgb(', '');
		hex = hex.replace(')', '');
		hex = hex.replace(' ', '');
		hex = hex.replace(' ', '');
		hex = hex.split(',');
	return { r: hex[0], g: hex[1], b: hex[2] };
}

$(window).on('load', function(){
	setTimeout(function(){
		if ( $('body').attr('id') == 'challenge' || location.pathname == '/challenge' ) {
			document.location.hash = 'challenge';
			$('html, body').scrollTop(0);
		}
	}, 150);

})



class Form {
  constructor() {}

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {};
    var i = 0;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = Form.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}




class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
	this.$siteNav = $('#site-nav--mobile');
    this.$siteOverlay = $('#site-overlay');

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  calculateMaxHeight(){
	document.querySelector('cart-drawer').style.maxHeight = window.innerHeight + 'px';
	
	}

  	async addToCart() {
		event.preventDefault();

		const addToCartButton = event.target;
		const cartOverlay = document.querySelector('.loader');
		cartOverlay?.classList.add('is-visible');
		document.body.style.overflowY = 'unset';
		
		// Disable the button
		addToCartButton.setAttribute("disabled", "disabled");

		const formElement = addToCartButton.closest("form");
		const formHelper = new Form();
		let serialized = formHelper.serialize(formElement);

		const isRecommenationItem = addToCartButton.closest(".CartRecommended--Wrapper");
		if (isRecommenationItem && !isRecommenationItem.querySelector("form")) {
			const productInput = isRecommenationItem.querySelector('input[name="product-id"]');
			const variantInput = isRecommenationItem.querySelector('input[name="id"]');

			if (!variantInput) return;

			serialized = {
				"id": variantInput.value,
				"product-id": productInput.value,
				"quantity": "1"
			}
		}
		
		try {
			const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
			body: JSON.stringify(serialized),
			credentials: "same-origin",
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "XMLHttpRequest",
			},
			});

			// Dispatch the event that total has changed
			document.dispatchEvent(new CustomEvent("total:changed", { bubbles: true }));

			if (!response.ok) {
				const content = await response.json();
				this.displayError(addToCartButton, content["description"]);
			}

			addToCartButton.removeAttribute("disabled");

			// Dispatch product added event
			this.element.dispatchEvent(new CustomEvent("product:added", {
				bubbles: true,
				detail: {
				variant: serialized.id,
				quantity: serialized.quantity,
				},
			}));

			// Handle cart update or reload
			if (window.location.href.includes("cart")) return location.reload();

			// Handle percentage off calculations and UI updates
			this.handleMobileNav();

		} catch (error) {
			console.error("Error adding to cart:", error);
			addToCartButton.removeAttribute("disabled");
		}
	}

	async updateCartData() {
		return new Promise((resolve, reject) => {
			$.ajax({
			url: `${window.routes.localeRootUrl}/cart`,
			success: (data) => {
				const cartData = $(data).find('cart-drawer');
				$('#site-cart').html(cartData[0]);
				
				const quantity = parseInt($(data).find('.CartMain').attr('data-quantity-total'));
				if (quantity) {
				$(".count").html(quantity);
				}

				window.theme.cartCount = quantity;
				resolve(data);
			},
			error: reject,
			});
		});
	}

	handleMobileNav() {
		this.$siteNav = $('#site-nav--mobile');
		this.$siteOverlay = $('#site-overlay');

		if (!this.$siteNav.hasClass('active')) {
			this.$siteNav.addClass('active').removeClass('show-filters show-search').addClass('show-cart');
			this.$siteOverlay.addClass('active');

			const popupOpened = document.querySelector('.popup');
			if (popupOpened) {
			popupOpened.style.display = 'none';
			}

			$('.fixing-scroll-now .site-box-background').addClass('sidebar-move');
			$('body').addClass('sidebar-move');

			setTimeout(() => {
			this.calculateMaxHeight();
			$('.site-close-handle, #site-overlay').on('click', () => {
				this.$siteNav.removeClass('active');
				document.querySelector("cart-drawer").setAttribute("aria-expanded", false);
				this.$siteOverlay.removeClass('active');
				$('body').removeClass('sidebar-move');
			});
			}, 300);
		}
	}

	displayError(button, message) {
		const errorMessageElement = document.createElement("span");
		errorMessageElement.className = "error-message";
		errorMessageElement.innerHTML = message;

		button.removeAttribute("disabled");
		button.insertAdjacentElement("afterend", errorMessageElement);

		setTimeout(() => {
			errorMessageElement.remove();
		}, 2500);
	}
}

function isElementInViewport (el) {

    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
}
function onVisibilityChange(el, callback) {
    var old_visible;
    return function () {
        var visible = isElementInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback();
            }
        }
    }
}
class Dropdown {
  constructor(element) {
    this.element = element;
    this.domDelegate = new Delegate(document.body);
    this.bindEvents();
  }

  bindEvents() {
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );
  }
  openDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
    dropdownButton.setAttribute("aria-expanded", true);
    dropdownContent.setAttribute("aria-hidden", false);

    gsap.timeline().from(dropdownContent, {
      y: -5,
      stagger: 0.1,
      duration: 0.8,
      //ease: "bounce",
      height: 1,
      overflow: "hidden",
    });
  }

  closeDropdown(elem) {
    const dropdownButton = elem.querySelector(".DropdownButton"),
      dropdownContent = elem.querySelector(".DropdownContent");
    dropdownButton.setAttribute("aria-expanded", false);
    dropdownContent.setAttribute("aria-hidden", true);
  }
  toggleDropdown(event, target) {
    event.preventDefault(event);
    const mainDropdown = target.closest(".Dropdown");
    var isOpen = target.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      this.closeDropdown(mainDropdown, target);
    } else {
      this.openDropdown(mainDropdown, target);
    }
  }
}


class FeaturedProductSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
      this.delegateElement = new Delegate(this.element);
    new AddToCart(this.element);
  }

connectedCallback(){
  this.delegateElement.on(
    "click",
    "[data-action=up_quantity]",
    this.changeQuantity.bind(this)
  );
  this.delegateElement.on(
    "click",
    "[data-action=down_quantity]",
    this.changeQuantity.bind(this)
  );

  this.delegateElement.on(
    "click",
    '[data-action="go-to-link"]',
    this.handleLinkClick.bind(this)
  );
}

disconnectedCallback() {
	this.delegateElement.destroy();
}

handleLinkClick() {
	const cartFunctions = event.target.closest('.cart-functions');	
	if (cartFunctions) return console.log("da");
	
	const link = event.target.closest('[data-action="go-to-link"]')?.dataset.link;	
	if (link) window.location.href = link;
}
 
changeQuantity(){
  event.preventDefault();
  let quantityHolder =  event.target.closest('.quantity-selector-holder');
let quantityToChange = event.target.closest('button').getAttribute('data-value');
let quantityInput = quantityHolder.querySelector('.quantity-selector');
quantityInput.value = parseInt(quantityInput.value) + parseInt(quantityToChange);
}
}

customElements.define("featured-product", FeaturedProductSection);

/*DISCOUNTS SETUP AUTOMATIC*/


  function isMobile() {
    const width = $(window).width();
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : width < 1025;
    return isMobile;
  }

//   class CustomReviews{
//   static load(){
//     let productWithReviewsIds = window.customReviews.products ? window.customReviews.products.split(',') : [];

//     let uniqueProductWithReviewsIds = [];
//     $.each(productWithReviewsIds, function(i, el){
//         if($.inArray(el, uniqueProductWithReviewsIds) === -1) uniqueProductWithReviewsIds.push(el);
//     });

//     productWithReviewsIds = uniqueProductWithReviewsIds;
//     let productIndex = 0;
//     let loads = 0;
//     const cascadeLoad = true;
//     const REVIEWS_PER_PAGE = 100;

//     window.reviewApp = window.reviewApp || {
//       paginator: null,
//       newlyLoaded: 0,
//       onLoad: true,
//       selectedPage: 0,
//       lastPage: 0,
//       globalPage: 1,
//       reviewsByPages:{},
//       reviewUrl:'https://productreviews.shopifycdn.com/proxy/v4/reviews/',
//       reviewStore: window.customReviews.permanent_domain, /* or hard code the myshopify url - eg: freakdesign.myshopify.com */
//     };


//     window.ReviewsByPageInit = function(){
//       const add = window.reviewApp.globalPage > 1 ? 1 : 0;
//       const lastPage = loads > 0 ? window.reviewApp.lastPage + 1 : window.reviewApp.lastPage;
//         const {reviewsPerPage, maxNumberOfPages} = initializeConstData();
//       var reviews_all = window.reviewApp.allReviews;

//       reviews_all.forEach((val, index) => {

//   const page = lastPage + Math.floor(index/reviewsPerPage) + add -1;

//   if(!window.reviewApp.reviewsByPages[page]){
//       window.reviewApp.reviewsByPages[page] = []
//   }
//    window.reviewApp.reviewsByPages[page].push(val)

// })
//     }

//     window.showReviewsOnPage = function(page, nextLoad = false){


//       if(nextLoad && window.reviewApp.newlyLoaded >= REVIEWS_PER_PAGE){
//         loads = 0;
//         productIndex = 0;
//         window.reviewApp.newlyLoaded = 0;
//         window.reviewApp.globalPage = window.reviewApp.globalPage +1;
//         reviewApp.getReviewsForProduct(productWithReviewsIds[productIndex], window.reviewApp.globalPage);
//         return
//       }
//       else if(nextLoad && window.reviewApp.newlyLoaded < REVIEWS_PER_PAGE){
//         window.reviewApp.paginator.setSelectedPage(page-1)
//         return;
//       }

//       var reviewsContainer = document.getElementsByClassName('Custom__Reviews')[0]
//     //  reviewsContainer.innerHTML = '';

//       page = page ? page : (window.reviewApp.globalPage -1 )*25; //page;


//       const reviews = window.reviewApp.reviewsByPages[page];
//       var icon = document.createElement('div');
//        icon.innerHTML = '<svg class="iconN" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_696_333)"><path d="M4.97197 12.424L5.82427 12.0422C5.93572 11.9923 6.06319 11.9923 6.17464 12.0422L7.02694 12.424C7.3976 12.59 7.83389 12.4731 8.07188 12.144L8.61911 11.3872C8.69068 11.2883 8.80106 11.2245 8.92255 11.212L9.85153 11.1165C10.2555 11.0749 10.5749 10.7555 10.6165 10.3515L10.712 9.42255C10.7245 9.30106 10.7882 9.19068 10.8872 9.11911L11.644 8.57188C11.9731 8.33389 12.09 7.89759 11.924 7.52694L11.5422 6.67464C11.4923 6.56319 11.4923 6.43572 11.5422 6.32427L11.924 5.47197C12.09 5.10131 11.9731 4.66502 11.644 4.42703L10.8872 3.8798C10.7882 3.80823 10.7245 3.69785 10.712 3.57636L10.6165 2.64738C10.5749 2.24337 10.2555 1.92398 9.85153 1.88243L8.92255 1.78688C8.80106 1.77439 8.69068 1.71066 8.61911 1.61169L8.07188 0.854949C7.83389 0.525842 7.3976 0.408938 7.02694 0.574958L6.17464 0.9567C6.06319 1.00662 5.93572 1.00662 5.82427 0.9567L4.97197 0.574958C4.60131 0.408938 4.16502 0.525842 3.92703 0.854949L3.3798 1.61169C3.30823 1.71066 3.19785 1.77439 3.07636 1.78688L2.14738 1.88243C1.74337 1.92398 1.42398 2.24337 1.38243 2.64738L1.28688 3.57636C1.27439 3.69785 1.21066 3.80823 1.1117 3.8798L0.354949 4.42703C0.0258419 4.66502 -0.091062 5.10131 0.0749575 5.47197L0.456703 6.32427C0.506625 6.43572 0.506625 6.56319 0.456703 6.67464L0.0749575 7.52694C-0.091062 7.89759 0.0258419 8.33389 0.354949 8.57188L1.1117 9.11911C1.21066 9.19068 1.27439 9.30106 1.28688 9.42255L1.38243 10.3515C1.42398 10.7555 1.74337 11.0749 2.14738 11.1165L3.07636 11.212C3.19785 11.2245 3.30823 11.2883 3.3798 11.3872L3.92703 12.144C4.16502 12.4731 4.60131 12.59 4.97197 12.424Z" fill="#06AFFF"/><line x1="3.13018" y1="6.90716" x2="4.5444" y2="8.32138" stroke="white" stroke-width="1.5"/><line x1="9.07598" y1="4.49174" x2="4.36194" y2="9.20579" stroke="white" stroke-width="1.5"/></g><defs><clipPath id="clip0_696_333"><rect width="12" height="12" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>';

//       if(Array.isArray(reviews)){
//         if(page > 0){
//           var newFloat = document.querySelector('.for_review').cloneNode(true);
//             reviewsContainer.appendChild(newFloat);
//         }
//         reviews.forEach(review => {
//           var myItem = review.querySelector('.spr-review-header-byline');
//           var myParent = review.querySelector('.spr-review-footer');


//           if(review.querySelector('.iconN') == null ){
//             review.querySelector('.accept').append(icon);
//           }
//           myParent.append(myItem);

//           reviewsContainer.appendChild(review);


//         })
//       }
//       $('.spr-review').last().addClass('last');


//       /* Pagination section*/
//       if(window.reviewApp.selectedPage != page){
//           const prevPage = document.getElementById(`Page${window.reviewApp.selectedPage}`)
//           if(prevPage){
//             prevPage.classList.remove('active');
//           }
//       }

//       const currentPage = document.getElementById(`Page${page}`);
//     //  currentPage.classList.add('active');

//       window.reviewApp.onLoad = false;
//       window.reviewApp.selectedPage = page;
//       if(window.reviewApp.selectedPage == window.reviewApp.lastPage){
//         $('#reviews-pagination').hide();
//       }
//     }

//     const initializeConstData = function(){
//         const maxNumberOfPages = window.customReviews.maxPages;

//         const mobile = isMobile();
//         let reviewsPerPage = 3;
//         if(mobile){
//             reviewsPerPage = window.customReviews.reviewsPerPageMobile;
//         }
//         else{
//             reviewsPerPage = window.customReviews.reviewsPerPage;
//         }

//         return {reviewsPerPage, maxNumberOfPages};
//     }



//     window.reviewLoaded = function(response){
//   const {reviewsPerPage, maxNumberOfPages} = initializeConstData();
//       /*Create div and find revies*/
//       var tmpDiv = document.createElement('div');
//       tmpDiv.innerHTML = response.reviews;
//       let reviews = tmpDiv.querySelectorAll('.spr-review');

//       /*NodeArray to array*/
//       reviews = Array.prototype.slice.call(reviews, 0);
//       window.reviewApp.newlyLoaded = window.reviewApp.newlyLoaded + reviews.length;

//       const add = window.reviewApp.globalPage > 1 ? 1 : 0;
//       const lastPage = loads > 0 ? window.reviewApp.lastPage + 1 : window.reviewApp.lastPage;

//       reviews.forEach((val, index) => {

//         if(!window.reviewApp.allReviews){
//           window.reviewApp.allReviews = [];
//         }
//         window.reviewApp.allReviews.push(val);

//       })



//       if(cascadeLoad){
//         productIndex = productIndex+1;
//         const productId = productWithReviewsIds[productIndex];

//         if(productId){

//           reviewApp.getReviewsForProduct(productId, window.reviewApp.globalPage)
//         }else{

//             window.ReviewsByPageInit();
//             const pages =  Object.keys(window.reviewApp.reviewsByPages);

//             if(pages.length > 0){
//               const nextLastPage = pages[pages.length-1]
//               window.reviewApp.lastPage = parseInt(nextLastPage);
//             }
//             if(maxNumberOfPages){
//               window.reviewApp.paginator = new Pagination('reviews-pagination', pages, showReviewsOnPage, maxNumberOfPages);
//             }  else{
//               window.reviewApp.paginator = new Pagination('reviews-pagination', pages, showReviewsOnPage);
//               }
//             showReviewsOnPage(0);

//         }
//       }else{

//           window.ReviewsByPageInit();
//         if(maxNumberOfPages){
//           window.reviewApp.paginator = new Pagination('reviews-pagination', pages, showReviewsOnPage, maxNumberOfPages);
//         }  else{
//           window.reviewApp.paginator = new Pagination('reviews-pagination', pages, showReviewsOnPage);
//           }
// showReviewsOnPage(0);

//       }


//       loads = loads +1;
//     };

//     reviewApp.getReviewsForProduct = function(productId, page = 1){

//         if(typeof productId === 'undefined'){ console.log('id not defined');return }
//         var script = document.createElement("script");

//         if(document.getElementById('singleReviewData')){
//           document.getElementById('singleReviewData').remove(); /* cleanup (optional) */
//         }

//         script.id = 'singleReviewData';
//         script.async = true;
//         script.src = [window.reviewApp.reviewUrl,'product?callback=reviewLoaded&shop=',window.reviewApp.reviewStore,'&product_id=',productId, `&page=${page}`].join('');

//       document.body.appendChild(script);

//     };

//     if(Array.isArray(productWithReviewsIds) && productWithReviewsIds.length > 0){
//         reviewApp.getReviewsForProduct(productWithReviewsIds[productIndex])
//     }

//   }
// }

function showReviews(obj, index, nextLoad){
  obj.selectedPage = index;
  obj.showReviewsOnPage(index, nextLoad);
}

class CartDrawer extends HTMLElement {
	static observedAttributes = ["aria-expanded"];

	constructor() {
	  super();
	  this.element = this;

	  this.delegateElement = new Delegate(this.element);
	  this.delegateBody = new Delegate(document.body);

	  new AddToCart(this.element);

	  const _this = this;
	  $(document).on('ready', function(){
		_this._calculateMaxHeight();
	  });
	}
  
	connectedCallback(){
		this.delegateElement.on("click", "[data-action=up_quantity]", this.changeQuantity.bind(this));
		this.delegateElement.on("click", "[data-action=down_quantity]", this.changeQuantity.bind(this));
		this.delegateElement.on("change", ".quantity-selector", this.changeQuantity.bind(this));
		this.delegateElement.on("click", "[data-action=remove]", this.removeQuantity.bind(this));
		this.delegateBody.on("product:added", this.rerenderCart.bind(this));

		this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);

		window.addEventListener('resize', this._calculateMaxHeightListener);

		requestAnimationFrame(() => {
			this.initUpsell();
		})
	}

	disconnectedCallback() {
		this.delegateElement.destroy();
		this.delegateBody.destroy();

		if (this._calculateMaxHeightListener) 
			removeEventListener('resize', this._calculateMaxHeightListener);
	}

	async initUpsell() {		
		const recommendationsWrapper = this.element.querySelector(".RecommendedItems");
		const recommendationsUrl = recommendationsWrapper?.dataset.recommendationsUrl;		

		if (!recommendationsUrl) return;

		const data = await this.fetchRecommendations(recommendationsUrl);
		const div = document.createElement("div");
		div.innerHTML = data;

		const newWrapper = div.querySelector(".cart__upsell-wrapper");
		if (!newWrapper) return;

		const oldWrapper = recommendationsWrapper.querySelector(".cart__upsell-wrapper");

		oldWrapper?.replaceWith(newWrapper);
	}

	async fetchRecommendations(url) {
		try {
			const response = await fetch(url);
			return await response.text();

		} catch(e) {
			console.log(e)
		}
	}

	_calculateMaxHeight(){
		this.element.style.maxHeight = window.innerHeight + 'px';
	}

	changeQuantity(event, target){
		event.preventDefault();
		let quantityHolder =  event.target.closest('.quantity-selector-holder');
		let quantityToChange = event.target.closest('button').getAttribute('data-value');
		let quantityInput = quantityHolder.querySelector('.quantity-selector');
		let quantity = parseInt(quantityInput.value) + parseInt(quantityToChange);
		quantityInput.value = quantity;
		this.updateQuantity(quantity, target);
  	}
  
	async updateQuantity(quantity, target) {
		try {
		  // Show loader
		  const cartOverlay = document.querySelector('.loader');
		  cartOverlay?.classList.add('is-visible');
		  
		  // Send POST request to update cart item quantity
		  const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'X-Requested-With': 'XMLHttpRequest', // Needed due to Shopify bug
			},
			credentials: 'same-origin',
			body: JSON.stringify({
			  id: target.getAttribute('data-line-id'),
			  quantity: quantity
			}),
		  });
	  
		  // Check if the response is okay
		  if (!response.ok) {
			throw new Error('Failed to update the cart');
		  }
	  
		  // Re-render the cart after successful response
		  await this.rerenderCart();
		} catch (error) {
		  console.error('Error updating quantity:', error);
		}
	}
  
  async removeQuantity(event, target){
	try {
		// Show loader
		const cartOverlay = document.querySelector('.loader');
		cartOverlay?.classList.add('is-visible');
		
		// Send POST request to update the cart
		const response = await fetch(`${window.routes.localeRootUrl}/cart/change.js`, {
		  method: 'POST',
		  headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest', // Needed due to Shopify bug
		  },
		  credentials: 'same-origin',
		  body: JSON.stringify({
			id: target.getAttribute('data-line-id'),
			quantity: 0
		  }),
		});
	
		// Check if the response is okay
		if (!response.ok) {
		  throw new Error('Failed to update the cart');
		}
	
		// Re-render the cart after successful response
		await this.rerenderCart();
	  } catch (error) {
		console.error('Error removing quantity:', error);
	  }
  	}
  
  	// Re-renders the cart page or updates the cart drawer asynchronously.
	async rerenderCart() {
		// If the current page is the cart page, reload the page
		if (window.location.href.includes("cart")) {
			window.location.reload();
			return;
		}

		try {
			const response = await fetch(`${window.routes.localeRootUrl}/cart`);
			const data = await response.text();
			
			this.updateCartHtml(data);
			
			this.element.dispatchEvent(
				new CustomEvent("refresh:discount", {
					bubbles: true
				})
			);

			this.closeCartOverlay();			

		} catch (error) {
			console.error('Error updating cart:', error);
		}
	}

	updateCartHtml(data) {		
		// Parse the response HTML to extract the relevant cart data		
		const parser = new DOMParser();
		const doc = parser.parseFromString(data, 'text/html');
		const cartData = doc.querySelector('cart-drawer');
		const quantity = parseInt(doc.querySelector('.CartMain').getAttribute('data-quantity-total'));

		// Update the global cart quantity and dispatch an event
		window.theme.cartCount = quantity;
		document.dispatchEvent(new CustomEvent("total:changed", { bubbles: true }));

		// Update the cart quantity in the UI
		if (quantity || quantity === 0) {
			document.querySelector('.count').innerHTML = quantity;
		}

		// Update the cart drawer with new content
		document.querySelector('#site-cart').innerHTML = cartData.outerHTML;
		document.querySelector('cart-drawer').style.maxHeight = `${window.innerHeight}px`;
		
		this.element = document.querySelector('cart-drawer');
	}

	// Close cart overlay after a delay and handle sidebar close functionality
	closeCartOverlay() {
		setTimeout(() => {
			document.querySelectorAll('.site-close-handle, #site-overlay').forEach(element => {
				element.addEventListener('click', () => {
					const siteNav = document.querySelector('#site-nav--mobile');
					const siteOverlay = document.querySelector('#site-overlay');

					if (siteNav.classList.contains('active')) {
						siteNav.classList.remove('active');
						siteOverlay.classList.remove('active');

						document.querySelector('.fixing-scroll-now .site-box-background')?.classList.remove('sidebar-move');
						document.body.classList.remove('sidebar-move');

						// Recalculate the max height after closing the sidebar
						this._calculateMaxHeight();
					}
				});
			});

			document.dispatchEvent(new CustomEvent("total:changed", { bubbles: true }));
		}, 300);
	}
  
	attributeChangedCallback(name, oldValue, newValue) {
		if (name === "aria-expanded") {
			this.toggleSwiperAnimations(newValue);
		}
	}

	toggleSwiperAnimations(turnOn) {		
		const swipers = this.element.querySelectorAll("swiper-init");
		if (!swipers.length) return;		
		
		if (turnOn === "true") {
			swipers.forEach(elem => {
				setTimeout(() => {
					elem.swiper.swiperElement.autoplay.resume();
				}, 100)
			});
		} else {
			swipers.forEach(elem => {				
				elem.swiper?.swiperElement?.autoplay.pause();
			})
		}
	}
}
  
customElements.define("cart-drawer", CartDrawer);
class Pagination{
    constructor(id, pages, showReviewsOnPage, maxpages = 5){
      this.selectedPage = 0;
      this.pageElements = []
      this.showReviewsOnPage = showReviewsOnPage;
      this.maxPages = maxpages;
        this.pagination = document.getElementById('reviews-pagination')

        this.pagination.innerHTML = '';

        this.totalPages = pages.length;
        this.minorPage = 0;
        this.majorPage = maxpages-1;
        this.addBackButton();



      //messy
      if(window.reviewApp.globalPage > 0){
      	const page = (window.reviewApp.globalPage -1 )*25;

        this.generateNextPageElements(this, page);
      }
    }

  generatePreviousPageElements(obj, from){
 	const temp = from - (obj.maxPages-1);
    const to = temp + obj.maxPages;
    from = temp
    for(let i = from, j = 1; i < to; i++, j++){
    	const element = this.pageElements[i];

      if(j <= this.maxPages){
        if(element){
          if(obj.pagination.children[j])
          	$(obj.pagination.children[j]).replaceWith(element);
          else
            obj.pagination.appendChild(obj.addPage(j-1));
        }
      }

    }

    if(!obj.pagination.children[this.maxPages+1]){
    	obj.addNextButton();
    }

    obj.minorPage = from;
    obj.majorPage = to;
    showReviews(obj, to-1)
  }

  generateNextPageElements(obj, from){
    let lastPage = 0;
    let lastIndex = 0;

    const to = from + obj.maxPages;
    for(let i = from, j = 1; i < to; i++, j++){
    	const element = this.pageElements[i];

      if(j <= this.maxPages){
        if(element){
          lastPage = i;
          lastIndex = j;
          $(obj.pagination.children[j]).replaceWith(element);
        }else{
          $(obj.pagination.children[lastIndex+1]).remove();
        }
      }

    }

    obj.minorPage = from;
    obj.majorPage = lastPage;


    showReviews(obj, from)
  }


    addPage(index){
        let child = document.createElement('a');
        child.setAttribute('id', `Page${index}`);
        child.setAttribute('class', 'Pagination__Selector');
        child.innerHTML = index+1;

        child.addEventListener('click', () => showReviews(this, index));


      return child;
    }

  backEventFunction(obj){
    let page = obj.selectedPage - 1;
    page = page <= 0 ? 0 : page;

    if(page < obj.minorPage){
      obj.generatePreviousPageElements(obj, page);
    }
    else{
    	showReviews(obj, page)
    }
  }

    nextEventFunction(obj){
      let page = window.reviewApp.selectedPage + 1;
      if(page === obj.totalPages){
        showReviews(obj, page, true)
        return;
      }

      if(page >= obj.minorPage + obj.maxPages && page < obj.totalPages){
      	obj.generateNextPageElements(obj, page)
      }
      else{
        page = page == obj.totalPages ? obj.totalPages -1 : page;
        showReviews(obj, page)
      }

    }

  setSelectedPage(page){
  	this.selectedPage = page;
  }


    addBackButton(){
        let back = document.createElement('a');
        back.setAttribute('id', `Next`);
        back.setAttribute('class', 'Pagination__Selector');
        back.innerHTML = 'SEE MORE';

        back.addEventListener('click', () => this.nextEventFunction(this));


            this.pagination.appendChild(back);


    }


}

class ToasterAnn extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
	new AddToCart(this.element);


  }
  bindEvents(){
    this.delegateElement.on('click','[data-action="toggle-wrapper"]', this.toggleWrapper.bind(this));

  }

  toggleWrapper(){

		$(".toasterHeading").toggleClass("toastActive");
		$(".toasterInnerContent").toggle("fast");

  }

}

customElements.define("toaster-ann", ToasterAnn);

class FindNewsletter extends HTMLElement {
	constructor() {
	  super();
	  this.element = this;
	  this.url = $('.FindNewsletterUrl').attr('data-url');
	  this.delegateElement = new Delegate(this.element);
	  this.bindEvents();
	}

	bindEvents(){
	  this.delegateElement.on('click','[data-action="find-newsletter"]', this.handleClick.bind(this));
	}

	handleClick() {
		event.stopPropagation();
		event.preventDefault();

		if (this.url !== '') {
			window.location.href = this.url;
		} else {
			window.location.href = '/pages/newsletter'
		}
	}
  }
  
  customElements.define("find-newsletter", FindNewsletter);

// Define a global function to load a script
window.loadScript = function(url) {
	// Check if the script already exists
	var existingScript = document.querySelector(`script[src="${url}"]`);

	if (existingScript) {
		return;
	}

	// Create a new script element
	var script = document.createElement('script');
	script.src = url;
	document.body.appendChild(script);
};

window.removeScript = function(url) {
    var scriptToRemove = document.querySelector(`script[src="${url}"]`);

    if (scriptToRemove) {
        scriptToRemove.parentNode.removeChild(scriptToRemove);
    }
};


class FakeReviews extends HTMLElement {
	constructor() {
	  super();
	  this.element = this;
	  this.delegate = new Delegate(this.element);
	  
	}

	connectedCallback(){
	  this.delegate.on('click','[data-action="show-more"]', this.showReviews.bind(this));
	}

	showReviews() {
		event.target.click();
		this.btnShow = this.element.querySelector('.btn__see-more');
		this.moreReviews = this.element.querySelectorAll('.review__wrapper--more');
		this.btnShow.style.display = 'none';
		this.moreReviews.forEach((review)=>{
			review.style.display = 'flex';
		})
	}
  }
  
  customElements.define("fake-reviews", FakeReviews);

  class LocalizationSelectors extends HTMLElement {
	constructor() {
	  super();
	  this.element = this;

	  this.initVariables();
	  this.updateButton();
	}

	initVariables() {
		this.delegateElement = new Delegate(this.element);
		this.delegateBody = new Delegate(document.body);
		this.mainButton = this.element.querySelector(".RevolutionSelectbox--Title");
	}

	updateButton() {
		const selected = this.element.querySelector('.select-language li[selected]');
		if (!selected) return;

		this.mainButton.innerHTML = selected.innerHTML; 
	}

	connectedCallback() {
		this.delegateBody.on('click', '[data-action="selectbox-change_lang"]', this.switchLanguage.bind(this));  
	}

    switchLanguage(event, target){
            event.preventDefault();
            let iso = event.target.dataset.language;

            const input = this.element.querySelector('[name="language_code"]');
            input.value = iso;
            var innerContent = event.target.innerHTML;

            if (this.mainButton) this.mainButton.innerHTML = innerContent;   
            input.parentElement.submit();
        }
  
  }

  customElements.define("localization-selectors", LocalizationSelectors);

  class ShippingTreshold extends HTMLElement {
    constructor() {
      super();
      this.element = this;
    }

	connectedCallback() {
		requestAnimationFrame(() => {
			this.init()
		})
	}

	disconnectedCallback() {
		if (!this.eventBind) return;
		document.removeEventListener('total:changed', this.eventBind);
	}

	init() {
	  this.initVariables();
	  if (!this.settings) return console.log("Settings are missing.", this);	  

      this.calcAmountLeft();

	  this.eventBind = this.calcAmountLeft.bind(this);
      document.addEventListener('total:changed', this.eventBind);
	}

	initVariables() {
      this.settings = this.element.querySelector('.ShippingTreshold--Settings');
	  if (!this.settings) return console.log("Settings are missing.");
   
      this.defaultTreshold = parseFloat(this.settings.getAttribute('data-default'));
      this.marketTresholds = this.settings.getAttribute('data-market');
      this.countryTresholds = this.settings.getAttribute('data-country');

      this.rate = Shopify.currency.rate;
      this.unit = this.settings.getAttribute('data-unit');
      this.shopifyCountry = Shopify.country;
	}

    calcAmountLeft() {

      this.cart = document.querySelector('.CartMain').dataset.lowprice;
      this.cart = parseFloat(this.cart / 100).toFixed(2);
      this.continent = window.theme.market;   
      let treshold = (this.defaultTreshold * this.rate);
      let amountLeft = treshold - this.cart;

      if (this.countryTresholds.includes(this.shopifyCountry)) {
        this.rate = 1;
        treshold = parseFloat(this.getTextInBetween(this.shopifyCountry + ':', ',', this.countryTresholds));
        if (treshold == -1){
          document.querySelector('shipping-treshold').style.display = "none";
        }
        amountLeft = (treshold * this.rate) - this.cart;

      } else if (this.marketTresholds.includes(this.continent)) {
     
        treshold = parseFloat(this.getTextInBetween(this.continent + ':', ',', this.marketTresholds));
        if (treshold == -1){
          document.querySelector('shipping-treshold').style.display = "none";
        }
        amountLeft = (treshold * this.rate) - this.cart;
      }



      this.showTresholdText(amountLeft.toFixed(2), treshold.toFixed(2), this.cart);
    }

    showTresholdText(amountLeft, treshold, cartTotal) {

      	if (amountLeft > 0) {
			const msg = this.element.querySelector('.ShippingTreshold--NotAchieved');
			const achived = this.element.querySelector('.ShippingTreshold--Achieved');
			msg.setAttribute('aria-hidden', 'false');
			achived.setAttribute('aria-hidden', 'true');
			
			const amount = this.unit === "kr" ? amountLeft + " " + this.unit : this.unit + amountLeft;
			let msgText = this.settings.dataset.shippingTresholdString || `You are xxxx away from getting free shipping`;
			msgText = msgText.replace("xxxx", amount);
			
			msg.innerText = msgText;
			const perc = (cartTotal / treshold) * 100;

          	this.element.querySelector('.meter[data-achieved="false"]').style.width = perc + '%';
        } else {
			const notAchived = this.element.querySelector('.ShippingTreshold--NotAchieved');
			const msg = this.element.querySelector('.ShippingTreshold--Achieved');
			msg.setAttribute('aria-hidden', 'false');
			this.element.querySelector('.meter[data-achieved="false"]').style.width = '100%';
			notAchived.setAttribute('aria-hidden', 'true');
        }
    }

    getTextInBetween(word1, word2, string) {
      let startIndex = string.indexOf(word1);
      string = string.substring(startIndex + word1.length, string.length);
      let endIndex = string.indexOf(word2);
      let result = 0;


      if (startIndex !== -1 && endIndex !== -1) {
        result = string.substring(0, endIndex);
      } else if (startIndex !== -1 && endIndex === -1) {
        result = string;
      }

      return result;
    }
  }
  
  customElements.define("shipping-treshold", ShippingTreshold);

  class RevolutionSwiper {
  constructor(element, additionalSwiper, pauseButton) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  toggleSwiper(target) {
    const paused = target.getAttribute("data-paused");

    if (paused === "true") {
      target.setAttribute("data-paused", "false");
      this.swiperElement.autoplay.run();
    } else if (paused === "false") {
      target.setAttribute("data-paused", "true");
      this.swiperElement.autoplay.pause();
    }
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    let configThumb = this.initialConfigThumbs;

    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.bindEvents();
  }

  bindEvents() {
    const _this = this;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });

    this.swiperElement.on("click", function () {
      const target = event.target.closest(".vjs-volume-control");
      if (!target) return;

      target.dispatchEvent(
        new CustomEvent("change:volume", { bubbles: true })
      )
    });
  }
}

  class SwiperInit extends HTMLElement {
    constructor() {
      super();
      this.element = this;
    }

	connectedCallback() {
		requestAnimationFrame(() => {
			this.swiper = new RevolutionSwiper(this.element);
		})
	}

	disconnectedCallback() {
		this.swiper.swiperElement.destroy();
	}
  }
  
  customElements.define("swiper-init", SwiperInit);